import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
  Divider,
  IconButton,
} from "@mui/material";
import axios from "axios";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import _, { isString } from "lodash";

import { exportMultipleSheetsAsExcel } from "ag-grid-enterprise";
import { serviceAPIMapping } from "../../config/service-api-mapping";
import {
  appColor,
  constants,
  EndPoint,
  LocateStatus,
  messages,
  quantityConfig,
} from "../../common/constants";
import { validateRate, validateTermDate } from "../../common/tradeValidations";
import SpinnerFullScreen from "../SpinnerFullScreen";
import { pageConstant } from "../../config/pageConstant";
import {
  convertToCommas,
  formatNumber,
  formatOptionLabel,
  hasAccess,
} from "../../common/commonFunctions";
import { Icon } from "@iconify/react";
import RefreshIcon from "@mui/icons-material/Refresh";
import moment from "moment";
import MuiAvatar from "@mui/material/Avatar";
import excel from "../../assets/images/excel.svg";
import swal from "sweetalert";
import "./style.css";
import { ToastContainer, toast } from "react-toastify";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import { WindowedMenuList } from "react-windowed-select";
import { useNavigate } from "react-router";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";

interface LocateAddersProps {
  selectedTab: string;
  refreshLocates: () => void;
  refreshPreBorrows: () => void;
  currentGridRef: any;
  isAdmin: any;
  insertNewRow?: (row: any) => void;
  refreshMostLocated: () => void;
  selectedTicker: any;
  currentGridApi: any;
  date: any;
  selectedRows: any;
  locateMostGridRef?: any;
  locateSupplyGridRef?: any;
  inquiryLocateRequest?: any;
  refreshInquiries?: any;
  filterSource?: (filter: any) => void;
  filterStatus?: (filter: any) => void;
  onInputTicker?: (ticker: string) => void;
  onResetFilter?: (isReset: boolean) => void;
  applyLocateSourceFilter?: (filter: any) => void;
  onDeselectAll?: () => void;
  applyLocateStatusFilter?: (filter: any) => void;
  onClearWorkbook?: () => void;
  onToggleTotalRow?: (isShow: boolean) => void;
  onShowFilledLocates?: (isFilled: boolean) => void;
  onCurrentKPITickerChange?: (ticker: any) => void;
  isRefreshTickerKPI?: boolean;
}

interface DataType {
  icon: string;
  stats: number;
  title: string;
  color: string;
  id: string;
}

interface LocateState {
  trading_account_id?: string;
  client: string;
  sec_id: string;
  quantity: any;
  rate: any;
  centsPerShare: any;
  comments: string;
  value: any;
}

const locateStateValueDefault: LocateState = {
  trading_account_id: "",
  client: "",
  sec_id: "",
  quantity: "",
  rate: "",
  centsPerShare: "",
  comments: "",
  value: "",
};

const LocateQtyStatsDefaults: DataType[] = [
  {
    stats: 0,
    title: "Original Qty",
    color: "primary",
    icon: "material-symbols:confirmation-number-outline-rounded",
    id: "sod_qty",
  },
  {
    color: "primary",
    stats: 0,
    title: "Approved Qty",
    icon: "marketeq:file-folder-approved-2",
    id: "appr_qty",
  },
  {
    color: "primary",
    stats: 0,
    title: "Remaining Qty",
    icon: "lets-icons:time-progress-duotone",
    id: "remaining_qnty",
  },

  {
    color: "primary",
    stats: 0,
    title: "Used Qty",
    icon: "material-symbols-light:pending-actions",
    id: "used_qnty",
  },
  {
    color: "primary",
    stats: 0,
    title: "Locate PNL",
    icon: "healthicons:dollar",
    id: "locate_pnl",
  },
  {
    color: "primary",
    stats: 0,
    title: "Total Locates",
    icon: "fluent-mdl2:total",
    id: "locate_count",
  },
];

const PreBorrowQtyStatsDefaults: DataType[] = [
  {
    color: "primary",
    stats: 0,
    title: "Pre Borrow SOD Qty",
    icon: "mdi:receipt-text-pending",
    id: "pre_borrow_sod_qnty",
  },
  {
    color: "primary",
    stats: 0,
    title: "Pre Borrow New Qty",
    icon: "mdi:receipt-text-pending",
    id: "pre_borrow_new_qnty",
  },
  {
    color: "primary",
    stats: 0,
    title: "Total Pre-Borrow Count",
    icon: "fluent-mdl2:total",
    id: "pre_borrow_count",
  },
];
const EnquiryStatsDefaults: DataType[] = [
  {
    color: "primary",
    stats: 0,
    title: "Approved Qty",
    icon: "material-symbols:order-approve-rounded",
    id: "appr_qty",
  },
  {
    color: "primary",
    stats: 0,
    title: "Pending Qty",
    icon: "mdi:receipt-text-pending",
    id: "pending_qnty",
  },
  {
    color: "primary",
    stats: 0,
    title: "Total Enquiry Count",
    icon: "fluent-mdl2:total",
    id: "total_count",
  },
];

const LocateAdders = (props: LocateAddersProps) => {
  const {
    selectedTab,
    refreshLocates,
    refreshPreBorrows,
    isAdmin,
    insertNewRow,
    refreshMostLocated,
    selectedTicker,
    currentGridApi,
    date,
    selectedRows,
    locateMostGridRef,
    locateSupplyGridRef,
    inquiryLocateRequest,
    refreshInquiries,
    onInputTicker,
    onResetFilter,
    applyLocateSourceFilter,
    applyLocateStatusFilter,
    onClearWorkbook,
    onToggleTotalRow,
    onShowFilledLocates,
    onCurrentKPITickerChange,
    isRefreshTickerKPI,
  } = props;

  const activeClient = "";
  const [values, setValues] = useState<LocateState>({
    trading_account_id: "",
    client: !isAdmin && !_.isUndefined(activeClient) ? activeClient ?? "" : "",
    sec_id: "",
    quantity: "",
    rate: "",
    centsPerShare: "",
    comments: "",
    value: "",
  });
  const [currentTicker, setCurrentTicker] = useState<any>(null);
  const [currentTickerDetails, setCurrentTickerDetails] = useState<any>(null);
  const [excelFileName, setExcelFileName] = useState("");
  const [excelLoader, setExcelLoader] = useState(false);

  const [tickerDetails, setTickerDetails] = useState<any>(null);
  const [tickerListMap, setTickerListMap] = useState<any>([]);
  const [secmasterList, setSecmasterList] = useState<any>([]);
  const [locateQuantities, setLocateQuantities] = useState<any>(
    LocateQtyStatsDefaults
  );
  const [preBorrowQuantities, setPreBorrowQuantities] = useState<any>(
    PreBorrowQtyStatsDefaults
  );
  const isSecurityNotAvailable = selectedRows?.some(
    (row: any) =>
      row?.comments?.trim()?.toLowerCase() === "security not available"
  );

  const isRegShoProhibited = selectedRows?.some(
    (row: any) =>
      row?.comments?.trim()?.toLowerCase() === "regsho name- prohibited"
  );

  const [currentClient, setCurrentClient] = useState<any>(null);
  const [isTickerHold, setIsTickerHold] = useState<boolean>(false);
  const [isTickerHoldDisabled, setIsTickerHoldDisabled] =
    useState<boolean>(false);

  const [isBulkUploadRunning, setIsBulkUploadRunning] = useState(false);
  const [rowsToSkip, setRowsToSkip] = useState<any>([]);
  const [showSkippedRowPopup, setShowSkippedRowPopup] = useState(false);
  const [isRequestSubmitted, setIsRequestSubmitted] = useState(false);
  const [isOverrideSubmitted, setIsOverrideSubmitted] = useState(false);
  const [isBulkUploadOpen, setIsBulkUploadOpen] = useState(false);
  const [rowsToUpload, setRowsToUpload] = useState<any>([]);
  const accountId = window.localStorage.getItem("activeAccountCode");
  const userName = window.localStorage.getItem("username");
  const clientRef = useRef<any>(null);
  const tickerRef = useRef<any>(null);
  const quantityRef = useRef<any>(null);
  const rateRef = useRef<any>(null);
  const commentsRef = useRef<any>(null);
  const centsPerShareRef = useRef<any>(null);
  const valueRef = useRef<any>(null);
  const [enquiryStats, setEnquiryStats] = useState<any>(EnquiryStatsDefaults);
  const navigate = useNavigate();

  const [clientOptions, setClientOptions] = useState<any>([]);
  const accessToken = window.localStorage.getItem("refreshtoken");
  const activeClientShortName = window.localStorage.getItem(
    "activeClientShortName"
  );
  const [lastUpdatedDate, setLastUpdatedDate] = useState(
    moment(new Date()).format("MM/DD/yyyy HH:mm")
  );

  const quantityWarnLimit = 500000;
  const quantityErrorLimit = 999999999;
  const headers = {
    "Content-Type": "application/json",
  };
  axios.defaults.headers.common = { Authorization: `Bearer ${accessToken}` };
  const globalSearchRef = useRef<any>(null);
  const [isSmallerDeviceRes, setIsSmallerDeviceRes] = useState<boolean>(
    window?.innerWidth <= 992
  );
  useEffect(() => {
    const handleResize = () => setIsSmallerDeviceRes(window.innerWidth <= 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [is14to16Res, setIsSmallersetIs14to16Res] = useState<boolean>(
    window?.innerWidth >= 1400 && window?.innerWidth <= 1700
  );
  const [rowsToSubmit, setRowsToSubmit] = useState<any>([]);
  const [isResetFilter, setIsResetFilter] = useState<boolean>(true);
  const [isUIFilterActive, setIsUIFilterActive] = useState<boolean>(false);
  const [isFileFilterActive, setIsFileFilterActive] = useState<boolean>(false);
  const [isFixFilterActive, setIsFixFilterActive] = useState<boolean>(false);
  const [statusFilter, setStatusFilter] = useState({
    isNewFilterActive: false,
    isApprovedFilterActive: false,
    isTopupFilterActive: false,
    isRejectedFilterActive: false,
    isPendingFilterActive: false,
    isPartialFilterActive: false,
  });
  const [isClearDisable, setIsClearDisable] = useState<boolean>(true);
  const [isMultiApproveDisable, setIsMultiApproveDisable] =
    useState<boolean>(true);
  const [isMultiRejectDisable, setIsMultiRejectDisable] =
    useState<boolean>(true);
  const [isMultiSaveDisable, setIsMultiSaveDisable] = useState<boolean>(true);
  const [isTopupRequestDisable, setIsTopupRequestDisable] =
    useState<boolean>(true);
  const [showTotalRow, setShowTotalRow] = useState<boolean>(
    isAdmin ? false : true
  );
  const [isShowFilledLocates, setIsShowFilledLocates] =
    useState<boolean>(false);
  const [isCPSEdit, setIsCPSEdit] = useState(false);
  const [cps, setCPS] = useState("");
  const handleChange =
    (prop: keyof LocateState) => (event: ChangeEvent<HTMLInputElement>) => {
      if (prop === "rate") {
        if (currentTicker?.price) {
          const centsPerShare = +(
            (currentTicker?.price * +event.target.value) /
            36000
          )?.toFixed(4);
          setValues({
            ...values,
            [prop]: event.target.value,
            centsPerShare: Math.abs(centsPerShare),
          });
        } else {
          setValues({ ...values, [prop]: event.target.value });
        }
      } else if (prop === "centsPerShare") {
        if (currentTicker?.price) {
          const rate = +(
            (+event.target.value * 36000) /
            currentTicker?.price
          )?.toFixed(3);
          setValues({
            ...values,
            [prop]: Math.abs(+(+event.target.value)?.toFixed(4)),
            rate: rate,
          });
        } else {
          setValues({
            ...values,
            [prop]: _.isEmpty(event.target.value)
              ? event.target.value
              : Math.abs(+(+event.target.value)?.toFixed(4)),
          });
        }
      } else {
        setValues({ ...values, [prop]: event.target.value });
      }
    };

  const handleFillFormClose = () => {
    setFillForm({
      lender: "",
      ticker: currentTickerDetails?.ticker ?? "",
      quantity: "",
      rate: "",
    });
    setFormErrors({
      lender: false,
      quantity: false,
      ticker: false,
      rate: false,
    });
    setIsFillPopupOpen(false);
  };

  const getTickerList = async () => {
    try {
      const options: any = [];

      let getTickerTextFieldRes: any = "";
      const raw = JSON.stringify({
        pageNumber: 0,
        pageSize: 0,
      });
      getTickerTextFieldRes = await axios.post(
        `${serviceAPIMapping["SECMASTER-SERVICE"].apiRouteURL}${EndPoint.secMaster}?account_id=${accountId}`,
        raw,
        { headers: headers }
      );
      if (!getTickerTextFieldRes) {
        // setOpen(true)
        // settickerSnackbarMessage(messages.TickerDownMessage)
      } else if (getTickerTextFieldRes.status === 200) {
        const tickerdataApi: any = getTickerTextFieldRes.data;
        for (let i = 0; i < tickerdataApi.length; i++) {
          const tempOptions: any = {
            value: tickerdataApi[i].ticker + "/" + tickerdataApi[i].cusip,
            label: tickerdataApi[i].name,
            ticker: tickerdataApi[i].ticker,
            cusip: tickerdataApi[i].cusip,
            name: tickerdataApi[i].name,
            price: tickerdataApi[i].price,
            sm_id: tickerdataApi[i].sm_id,
            isin: tickerdataApi[i].isin,
            cins: tickerdataApi[i].cins,
            date: tickerdataApi[i].date,
            updatedTime: tickerdataApi[i].updatedTime,
          };
          options.push(tempOptions);
        }
        setSecmasterList(options);
        setTickerListMap(new Map(options.map((t: any) => [t.cusip, t])));
        if (tickerListMap) {
          setTickerListMap(
            new Map(options.map((t: any) => [t.ticker.toUpperCase(), t]))
          );
        }
      } else if (getTickerTextFieldRes.status === 401) {
        //logout(channel)
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  const onSubmitLocate = async (
    isInquiry = false,
    isLocateRequest = false,
    isOverride = false
  ) => {
    setIsRequestSubmitted(isLocateRequest || isInquiry);
    setIsOverrideSubmitted(isOverride);
    const isRateValid =
      isOverride && isAdmin
        ? isPriceValid()
        : !_.isNaN(values?.rate) && !_.isEmpty(values?.rate)
        ? isPriceValid()
        : true;
    if (validateRequest() && isRateValid) {
      let counter = 0;
      setCurrentTickerDetails((tDetails: any) => {
        if (
          tDetails &&
          tDetails?.isregsho &&
          (_.isEmpty(values.comments) || !values.comments)
        ) {
          swal({
            icon: "warning",
            text: `Ticker party Regsho list, you sure you want to proceed with Locate? If you choose to continue, you will need to provide a comment.`,
            dangerMode: false,
            closeOnClickOutside: false,
            buttons: ["No", "Yes"],
          }).then((isConfirm: boolean) => {
            if (isConfirm) {
              handleInputFocus("comments");
              // generateLocateRequest(isInquiry, isLocateRequest, isOverride);
            } else {
              handleInputFocus("ticker");
            }
          });
        } else if (
          selectedTab === "Locates" &&
          isOverride &&
          counter === 0 &&
          tDetails &&
          tDetails?.ticker &&
          tDetails?.remaining_qnty <= 0 &&
          (_.isEmpty(values.comments) || !values.comments)
        ) {
          swal({
            icon: "warning",
            text: `No Qty is available - if you want to proceed, please specify the source/supply in the comments.`,
            dangerMode: false,
            closeOnClickOutside: false,
          }).then(() => {
            handleInputFocus("comments");
          });
        } else {
          if (counter === 0) {
            generateLocateRequest(isInquiry, isLocateRequest, isOverride);
          }
        }
        counter++;
        return tDetails;
      });
    }
  };

  const generateLocateRequest = (
    isInquiry = false,
    isLocateRequest = false,
    isOverride = false
  ) => {
    const isRateValid =
      isOverride && isAdmin
        ? isPriceValid()
        : !_.isNaN(values?.rate) && !_.isEmpty(values?.rate)
        ? isPriceValid()
        : true;

    if (validateRequest() && isRateValid) {
      const accrual = (values?.value * values.rate) / 36000;

      const sendRequest = {
        isInquiry: isInquiry,
        isValidate: true,
        isSubmit: true,
        isPreborrow: false,
        locate_src: "UI",
        locateApprovedRequest: [
          {
            batch: null,
            client: isAdmin
              ? values?.client?.trim()
              : activeClientShortName?.trim(),
            date: "",
            filename: "",
            qty_req: values.quantity,
            rate_req: values.rate,
            sec_id: values.sec_id,
            sec_id_type: "T",
            sm_id: "",
            updatedtime: "",
            user_id: userName,
            account_id: accountId,
            trading_account_id: "",
            centsPerShare: values?.centsPerShare,
            comments: values?.comments,
            is_wip: false,
            locate_id: 0,
            quantity: 0,
            rate: values.rate,
            qnty_fill: 0,
            qnty_req: values.quantity,
            cpty: isAdmin
              ? values?.client?.trim()
              : activeClientShortName?.trim(),
            accrual: _.isNaN(accrual) ? 0 : accrual,
            bl: 0,
            dtc: 0,
            value: values?.value,
          },
        ],
      };

      const saveRequest = {
        isInquiry: isInquiry,
        isValidate: true,
        isSubmit: true,
        isPreborrow: false,
        locate_src: "UI",

        locateApprovedRequest: [
          {
            batch: null,
            client: isAdmin
              ? values?.client?.trim()
              : activeClientShortName?.trim(),
            date: "",
            filename: "",
            qty_req: values.quantity,
            rate_req: values.rate,
            sec_id: values.sec_id,
            sec_id_type: "T",
            sm_id: "",
            updatedtime: "",
            user_id: userName,
            account_id: accountId,
            trading_account_id: "",
            centsPerShare: values?.centsPerShare,
            comments: values?.comments,
            is_wip: false,
            locate_id: 0,
            quantity: values.quantity,
            rate: values.rate,
            qnty_fill: 0,
            qnty_req: 0,
            cpty: isAdmin
              ? values?.client?.trim()
              : activeClientShortName?.trim(),
            accrual: _.isNaN(accrual) ? 0 : accrual,
            bl: 0,
            dtc: 0,
            value: values?.value,
          },
        ],
      };

      submitLocate(
        isAdmin && !isLocateRequest ? saveRequest : sendRequest,
        isLocateRequest
      )?.then(() => {
        setIsRequestSubmitted(false);
        setIsOverrideSubmitted(false);
        setValues(locateStateValueDefault);

        setCurrentClient(null);
        setCurrentTicker(null);
      });
    }
  };

  const showQuantityValidationAlert = () => {
    if (
      selectedTab === "Locates" &&
      currentTickerDetails &&
      currentTickerDetails?.ticker &&
      currentTickerDetails?.remaining_qnty <= 0 &&
      values?.quantity > 0
    ) {
      swal({
        icon: "warning",
        text: `No Qty is available - if you want to proceed, please specify the source/supply in the comments.`,
        dangerMode: false,
        closeOnClickOutside: false,
      }).then(() => {
        if (values?.rate) handleInputFocus("comments");
        else handleInputFocus("rate");
      });
    } else if (
      values?.quantity > quantityWarnLimit &&
      values?.quantity < quantityErrorLimit
    ) {
      swal({
        icon: "warning",
        text: `Locate Quantity entered is greater than 500k, Do you want to Continue?`,
        dangerMode: false,
        closeOnClickOutside: false,
        buttons: ["No", "Yes"],
      }).then((isConfirm: boolean) => {
        if (!isConfirm) {
          setValues((vl: any) => {
            return { ...vl, quantity: "" };
          });
          handleInputFocus("quantity");
        } else {
          handleInputFocus("rate");
        }
      });
    } else if (values?.quantity > quantityErrorLimit) {
      swal({
        icon: "warning",
        text: `You cannot enter a quantity greater than ${convertToCommas(
          quantityErrorLimit
        )}`,
        dangerMode: false,
        closeOnClickOutside: false,
      }).then(() => {
        setValues((vl: any) => {
          return { ...vl, quantity: "" };
        });
        handleInputFocus("quantity");
      });
    }
  };

  const onQtyBlur = () => {
    if (selectedTab === "Pre Borrow") {
      if (currentTickerDetails && currentTickerDetails?.price) {
        setValues((vl: any) => {
          let value = +vl.quantity * currentTickerDetails?.price;
          return { ...vl, value: isNaN(value) ? "" : value?.toFixed(2) };
        });
      }
    }
    showQuantityValidationAlert();
  };
  const showCentsPerShareAlert = () => {
    swal({
      icon: "warning",
      text: `Cents Per Share entered is greater than or equal to $1, Do you want to Continue? `,
      dangerMode: false,
      closeOnClickOutside: false,
      buttons: ["No", "Yes"],
      className: "swal-confirm-color",
    }).then((isConfirm: any) => {
      if (_.isNull(isConfirm)) {
        setValues((vl: any) => {
          return { ...vl, centsPerShare: "", rate: "" };
        });
      }
    });
  };

  const showRatesAlert = () => {
    swal({
      icon: "warning",
      text: `Rate is outside range between -999 and 6, Do you want to proceed?`,
      dangerMode: false,
      closeOnClickOutside: false,
      className: "swal-confirm-color",
      buttons: ["No", "Yes"],
    }).then((isConfirm: any) => {
      if (isConfirm) {
        if (
          selectedTab === "Pre Borrow" &&
          !_.isNaN(values?.centsPerShare) &&
          !_.isNaN(values?.rate) &&
          !_.isNaN(values?.value)
        ) {
          handleInputFocus("value");
        } else {
          values?.centsPerShare
            ? handleInputFocus("comments")
            : handleInputFocus("centsPerShare");
        }
      } else {
        setValues((vl: any) => {
          return { ...vl, centsPerShare: "", rate: "" };
        });
        handleInputFocus("rate");
      }
    });
  };

  const submitLocate = async (
    request: any,
    isLocateRequest = false,
    isLocateFromGrid = false
  ) => {
    try {
      // const endpoint = isAdmin
      //   ? isLocateRequest
      //     ? EndPoint.sendRestLocateRequest
      //     : EndPoint.saveLocateApproved
      //   : selectedTab === "Enquiry" && !isLocateFromGrid
      //   ? EndPoint.sendRestAvailabilityInquiry
      //   : EndPoint.sendRestLocateRequest;

      let endpoint = EndPoint.saveOrderRequest;
      if (selectedTab === "Enquiry" && !isLocateFromGrid) {
        endpoint = isAdmin
          ? EndPoint.saveQuoteInquiry
          : EndPoint.sendQuoteInquiry;
      } else {
        endpoint =
          isAdmin && !isLocateRequest
            ? EndPoint.saveOrderRequest
            : EndPoint.sendOrderRequest;
      }

      axios.defaults.headers.common = {
        Authorization: `Bearer ${accessToken}`,
      };
      await axios
        .post(
          `${serviceAPIMapping["LOCATEMANAGEMENT-SERVICE"].apiRouteURL}${endpoint}`,
          JSON.stringify(request),
          {
            headers: headers,
          }
        )
        .then((response: any) => {
          if (response && response?.status === 200) {
            if (response?.hasError) {
              swal({
                icon: "error",
                text: `Submit ${
                  selectedTab === "Locates" ? "Locate" : "Pre Borrow"
                } is failed with response status - ${
                  response?.status
                } and error ${response?.error}`,
                dangerMode: false,
                closeOnClickOutside: false,
              });
            } else {
              if (selectedTab === "Locates") {
                if (!_.isUndefined(response?.data?.responseEntity)) {
                  insertNewRow?.(response?.data?.responseEntity);
                  const ticker = response?.data?.responseEntity?.find(
                    (t: any) => t?.ticker === tickerDetails?.ticker
                  );
                  if (ticker?.status !== LocateStatus.Rejected) {
                    onTickerChange(ticker?.ticker);
                  }
                } else if (!_.isUndefined(response?.data?.locateResponseList)) {
                  insertNewRow?.(response?.data?.locateResponseList);
                  const ticker = response?.data?.locateResponseList?.find(
                    (t: any) => t?.ticker === tickerDetails?.ticker
                  );
                  if (ticker?.status !== LocateStatus.Rejected) {
                    onTickerChange(ticker?.ticker);
                  }
                }
              } else if (selectedTab === "Enquiry") {
                if (selectedTab === "Enquiry" && !isLocateFromGrid) {
                  insertNewRow?.(response?.data?.inquiryResponseList);
                }
                toast.success(
                  `${
                    isLocateFromGrid
                      ? inquiryLocateRequest?.isPreBorrow
                        ? "Pre Borrow saved successfully"
                        : "Locate saved successfully"
                      : "Inquiry saved successfully"
                  }`
                );
                // refreshInquiries?.();
              }
              if (selectedTab === "Pre Borrow") {
                if (!_.isUndefined(response?.data?.responseEntity)) {
                  insertNewRow?.(response?.data?.responseEntity);
                }
              }
            }
          } else {
            swal({
              icon: "error",
              text: `Submit locate is failed with response status - ${response?.status} and error ${response?.error}`,
              dangerMode: false,
              closeOnClickOutside: false,
            });
          }
        });
    } catch (error: any) {
      if (error?.response?.data?.hasError) {
        swal({
          icon: "error",
          text: `Submit locate is failed with error - "${error?.response?.data?.errorMessage}"`,
          dangerMode: false,
          closeOnClickOutside: false,
        });
      } else {
        swal({
          icon: "error",
          text: `Submit locate is failed with error ${error}`,
          dangerMode: false,
          closeOnClickOutside: false,
        });
      }
      if (selectedTab === "Locates") {
        if (!_.isUndefined(error?.response?.data?.responseEntity)) {
          insertNewRow?.(error?.response?.data?.responseEntity);
          const ticker = error?.response?.data?.responseEntity?.find(
            (t: any) => t?.ticker === tickerDetails?.ticker
          );
          if (ticker?.status !== LocateStatus.Rejected) {
            onTickerChange(ticker?.ticker);
          }
        } else if (!_.isUndefined(error?.response?.data?.locateResponseList)) {
          insertNewRow?.(error?.response?.data?.locateResponseList);
          const ticker = error?.response?.data?.locateResponseList?.find(
            (t: any) => t?.ticker === tickerDetails?.ticker
          );
          if (ticker?.status !== LocateStatus.Rejected) {
            onTickerChange(ticker?.ticker);
          }
        }
      }
    } finally {
      handleInputFocus("client");
      setIsOverrideSubmitted(false);
      setIsRequestSubmitted(false);
      setValues(locateStateValueDefault);
      setCurrentClient(null);
      setCurrentTicker(null);
    }
  };

  const validateQuantity = (quantity: any) => {
    return (
      (quantity &&
        quantity % 1 === 0 &&
        quantity >= quantityConfig.min &&
        quantity < quantityErrorLimit) === true
    );
  };

  const isPriceValid = () => {
    const isValid = validateRate(values?.rate);

    return isValid;
  };

  const isCentsPerShareValid = () => {
    const isValid = isOverrideSubmitted
      ? !_.isNaN(values?.centsPerShare)
      : values?.centsPerShare
      ? !_.isNaN(values?.centsPerShare)
      : true;

    return isValid;
  };

  const validateRequest = (): boolean => {
    const isValid =
      (isAdmin ? !_.isEmpty(values?.client) : true) &&
      !_.isEmpty(values?.sec_id) &&
      validateQuantity(values?.quantity) &&
      isCentsPerShareValid() &&
      (currentTicker?.isNewTicker
        ? true
        : tickerDetails?.ticker && !_.isNull(tickerDetails?.ticker));
    return isValid;
  };

  const submitPreBorrow = async () => {
    setIsOverrideSubmitted(true);
    //setIsRequestSubmitted(!isAdmin);

    if (validateRequest() && isPriceValid() && values?.value) {
      if (values?.value > 250000000) {
        swal({
          icon: "warning",
          text: `Contract value entered is bigger than 250M. Do you want to continue?`,
          dangerMode: false,
          closeOnClickOutside: false,
          buttons: ["No", "Yes"],
        }).then((isConfirm: boolean) => {
          if (!isConfirm) {
            setValues((vl: any) => {
              return { ...vl, value: "", quantity: "" };
            });
            handleInputFocus("'quantity'");
          } else {
            const accrual = (values?.value * values.rate) / 36000;
            // const clientRequest = {
            //   isValidate: false,
            //   locate_src: "UI",
            //   preBorrowRequest: [
            //     {
            //       accrual: _.isNaN(accrual) ? 0 : accrual,
            //       bl: 0,
            //       cpty: isAdmin ? values.client.trim() : activeClientShortName,
            //       date: "",
            //       dtc: 0,
            //       quantity: values.quantity,
            //       rate: values.rate,
            //       sec_id: values.sec_id,
            //       sec_id_type: "T",
            //       sm_id: "",
            //       updatedtime: "",
            //       user_id: userName,
            //       value: values?.value,
            //       centsPerShare: values?.centsPerShare,
            //       trading_account_id: "",
            //       account_id: accountId,
            //     },
            //   ],
            // };
            // onSubmitPreborrow(clientRequest);

            const sendRequest = {
              isInquiry: false,
              isValidate: true,
              isSubmit: true,
              isPreborrow: true,
              locate_src: "UI",
              locateApprovedRequest: [
                {
                  batch: null,
                  client: isAdmin
                    ? values?.client?.trim()
                    : activeClientShortName?.trim(),
                  date: "",
                  filename: "",
                  qty_req: values.quantity,
                  rate_req: values.rate,
                  sec_id: values.sec_id,
                  sec_id_type: "T",
                  sm_id: "",
                  updatedtime: "",
                  user_id: userName,
                  account_id: accountId,
                  trading_account_id: "",
                  centsPerShare: values?.centsPerShare,
                  comments: values?.comments,
                  is_wip: false,
                  locate_id: 0,
                  quantity: 0,
                  rate: values.rate,
                  qnty_fill: 0,
                  qnty_req: values.quantity,
                  cpty: isAdmin
                    ? values?.client?.trim()
                    : activeClientShortName?.trim(),
                  accrual: _.isNaN(accrual) ? 0 : accrual,
                  bl: 0,
                  dtc: 0,
                  value: values?.value,
                },
              ],
            };

            const saveRequest = {
              isInquiry: false,
              isValidate: true,
              isSubmit: true,
              isPreborrow: true,
              locate_src: "UI",

              locateApprovedRequest: [
                {
                  batch: null,
                  client: isAdmin
                    ? values?.client?.trim()
                    : activeClientShortName?.trim(),
                  date: "",
                  filename: "",
                  qty_req: values.quantity,
                  rate_req: values.rate,
                  sec_id: values.sec_id,
                  sec_id_type: "T",
                  sm_id: "",
                  updatedtime: "",
                  user_id: userName,
                  account_id: accountId,
                  trading_account_id: "",
                  centsPerShare: values?.centsPerShare,
                  comments: values?.comments,
                  is_wip: false,
                  locate_id: 0,
                  quantity: values.quantity,
                  rate: values.rate,
                  qnty_fill: 0,
                  qnty_req: 0,
                  cpty: isAdmin
                    ? values?.client?.trim()
                    : activeClientShortName?.trim(),
                  accrual: _.isNaN(accrual) ? 0 : accrual,
                  bl: 0,
                  dtc: 0,
                  value: values?.value,
                },
              ],
            };

            submitLocate(isAdmin ? saveRequest : sendRequest, false, false);
          }
        });
      } else {
        const accrual = (values?.value * values.rate) / 36000;
        const sendRequest = {
          isInquiry: false,
          isValidate: true,
          isSubmit: true,
          isPreborrow: true,
          locate_src: "UI",
          locateApprovedRequest: [
            {
              batch: null,
              client: isAdmin
                ? values?.client?.trim()
                : activeClientShortName?.trim(),
              date: "",
              filename: "",
              qty_req: values.quantity,
              rate_req: values.rate,
              sec_id: values.sec_id,
              sec_id_type: "T",
              sm_id: "",
              updatedtime: "",
              user_id: userName,
              account_id: accountId,
              trading_account_id: "",
              centsPerShare: values?.centsPerShare,
              comments: values?.comments,
              is_wip: false,
              locate_id: 0,
              quantity: 0,
              rate: values.rate,
              qnty_fill: 0,
              qnty_req: values.quantity,
              cpty: isAdmin
                ? values?.client?.trim()
                : activeClientShortName?.trim(),
              accrual: _.isNaN(accrual) ? 0 : accrual,
              bl: 0,
              dtc: 0,
              value: values?.value,
            },
          ],
        };

        const saveRequest = {
          isInquiry: false,
          isValidate: true,
          isSubmit: true,
          isPreborrow: true,
          locate_src: "UI",

          locateApprovedRequest: [
            {
              batch: null,
              client: isAdmin
                ? values?.client?.trim()
                : activeClientShortName?.trim(),
              date: "",
              filename: "",
              qty_req: values.quantity,
              rate_req: values.rate,
              sec_id: values.sec_id,
              sec_id_type: "T",
              sm_id: "",
              updatedtime: "",
              user_id: userName,
              account_id: accountId,
              trading_account_id: "",
              centsPerShare: values?.centsPerShare,
              comments: values?.comments,
              is_wip: false,
              locate_id: 0,
              quantity: values.quantity,
              rate: values.rate,
              qnty_fill: 0,
              qnty_req: 0,
              cpty: isAdmin
                ? values?.client?.trim()
                : activeClientShortName?.trim(),
              accrual: _.isNaN(accrual) ? 0 : accrual,
              bl: 0,
              dtc: 0,
              value: values?.value,
            },
          ],
        };
        submitLocate(isAdmin ? saveRequest : sendRequest, false, false);
      }
    }
  };

  const makeRequest = (
    method: string,
    url: string,
    success: (data: any) => void,
    error: (error: any) => void
  ) => {
    const httpRequest = new XMLHttpRequest();
    httpRequest.open("GET", url, true);
    httpRequest.responseType = "arraybuffer";

    httpRequest.open(method, url);
    httpRequest.onload = function () {
      success(httpRequest.response);
    };
    httpRequest.onerror = function () {
      error(httpRequest.response);
    };
    httpRequest.send();
  };

  const onUploadExcel = (e: any) => {
    makeRequest(
      "GET",
      `${URL.createObjectURL(e.target.files[0])}`,
      function (data) {
        const workbook = convertDataToWorkbook(data);
        populateGrid(workbook, e.target.files[0].name);
      },
      function (error) {
        //turning the flag false, so it can represents that the uploading process has been stoped.
        throw error;
      }
    );
  };

  const convertDataToWorkbook = (dataRows: any) => {
    const data = new Uint8Array(dataRows);
    const arr = [];
    for (let i = 0; i !== data.length; ++i) {
      arr[i] = String.fromCharCode(data[i]);
    }
    const bstr = arr.join("");

    return XLSX.read(bstr, { type: "binary" });
  };

  const onClear = () => {
    setExcelFileName("");
    setRowsToUpload([]);
  };

  const populateGrid = async (workbook: XLSX.WorkBook, name: any) => {
    setExcelLoader(true);
    const tempArray: any = [];
    let tempObj: any = {};
    const rowsToSkip: any = [];
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const columns: Record<string, string> = {
      A: "client",
      B: "ticker",
      C: "share",
      D: "rate",
      E: "cents_per_share",
    };

    if (worksheet["A1"].v === columns.A) {
      setExcelFileName(name);
      let rowIndex = 2;
      if (worksheet["A" + rowIndex] === undefined) {
        const obj = {
          h: "",
          r: "<t>'</t>",
          t: "s",
          v: "",
          w: "",
        };
        worksheet["A" + rowIndex] = obj;
      }
      const expceFileRows: any =
        XLSX.utils.sheet_to_json(worksheet, { blankrows: false, defval: "" })
          .length + 1;
      try {
        while (expceFileRows >= rowIndex) {
          const row: any = {};
          const workRowA =
            worksheet["A" + rowIndex] === undefined
              ? ""
              : worksheet["A" + rowIndex].v;
          if (workRowA !== "#") {
            Object.keys(columns).forEach((column) => {
              row[columns[column]] = worksheet[column + rowIndex]?.w;
            });

            row.status = constants.UI_STATUS_NEW;
            row.isSkip = false;
            // row.error_status = '';
            const client = clientOptions?.find(
              (c: any) =>
                c?.shortName?.trim()?.toLowerCase() ===
                row?.client?.trim()?.toLowerCase()
            );

            if (
              isAdmin &&
              (_.isUndefined(row.client) ||
                _.isUndefined(client) ||
                _.isNull(row.client) ||
                (_.isString(row.client) && _.isEmpty(row.client?.trim())))
            ) {
              row.status = constants.Error;
              row.isSkip = true;
              rowsToSkip.push(rowIndex);
            }
            const ticker = tickerListMap?.get(row?.ticker?.toUpperCase());
            if (
              _.isUndefined(ticker) ||
              _.isUndefined(row.ticker) ||
              _.isNull(row.ticker) ||
              (_.isString(row.ticker) && _.isEmpty(row.ticker?.trim()))
            ) {
              row.status = constants.Error;
              row.rejected_error_reasons = messages.InvalidTicker;
              row.isSkip = true;
              rowsToSkip.push(rowIndex);
            }

            if (
              isAdmin &&
              (_.isNaN(row?.rate) ||
                _.isEmpty(row?.rate) ||
                _.isNull(row?.rate) ||
                _.isUndefined(row?.rate)) &&
              (_.isNaN(row?.cents_per_share) ||
                _.isNull(row?.cents_per_share) ||
                _.isUndefined(row?.cents_per_share))
            ) {
              // row.status = constants.Error;
              // row.rejected_error_reasons = messages.InvalidRate;
              // row.error_status = messages.InvalidRate;
              // rowsToSkip.push(rowIndex);
            }

            if (isString(row?.share) && row?.share?.includes(",")) {
              row.share = row?.share?.replace(/,/g, "");
            }

            if (
              !row.share ||
              isNaN(row.share) ||
              row.share <= 0 ||
              row.share > quantityErrorLimit
            ) {
              row.status = constants.Error;
              row.error_status = "Invalid Req Quantity";
              row.rejected_error_reasons = "Invalid Req Quantity";
              // rowsToSkip.push(rowIndex);
            }

            row.cents_per_share = _.isNaN(row.cents_per_share)
              ? ""
              : Math.abs(row.cents_per_share);

            if (row.status === constants.UI_STATUS_NEW || !row.isSkip) {
              const centsPerShare =
                !_.isNaN(row?.rate) &&
                !_.isEmpty(row?.rate) &&
                !_.isNull(row?.rate) &&
                !_.isUndefined(row?.rate)
                  ? ticker
                    ? Math.abs(
                        +((ticker?.price * +row.rate) / 36000)?.toFixed(4)
                      )
                    : ""
                  : row?.cents_per_share;

              const rate =
                (_.isNaN(row?.rate) ||
                  _.isEmpty(row?.rate) ||
                  _.isNull(row?.rate) ||
                  _.isUndefined(row?.rate)) &&
                !_.isNaN(row?.cents_per_share)
                  ? +((+row?.cents_per_share * 36000) / ticker?.price)?.toFixed(
                      3
                    )
                  : row?.rate;

              tempObj = isAdmin
                ? {
                    batch: null,
                    client: row?.client?.trim(),
                    date: "",
                    filename: "",
                    qty_req: row.share,
                    rate_req: rate,
                    //rateOrCents === "centsPerShare" ? rate : row?.rate,
                    sec_id: row.ticker?.toUpperCase(),
                    sec_id_type: "T",
                    sm_id: "",
                    updatedtime: "",
                    user_id: userName,
                    account_id: accountId,
                    trading_account_id: "",
                    centsPerShare: centsPerShare,
                    // rateOrCents === "rate"
                    //   ? centsPerShare
                    //   : row?.cents_per_share,
                    comments: "",
                    is_wip: true,
                    locate_id: 0,
                    quantity: row.share,
                    rate: rate,
                    qnty_fill: 0,
                    qnty_req: 0,
                    cpty: row?.client?.trim(),
                    accrual: (ticker?.price * row.rate * row.share) / 36000,
                    bl: 0,
                    dtc: 0,
                    value: row.share * ticker?.price,
                    tickerPrice: ticker?.price,
                    error_status: row?.error_status,
                    //  status: row?.error_status?.length>0?'Error':'New'
                  }
                : {
                    batch: null,
                    client: activeClientShortName?.trim(),
                    date: "",
                    filename: "",
                    qty_req: row.share,
                    rate_req: rate,
                    // rateOrCents === "centsPerShare" ? rate : row?.rate,
                    sec_id: row.ticker?.toUpperCase(),
                    sec_id_type: "T",
                    sm_id: "",
                    updatedtime: "",
                    user_id: userName,
                    account_id: accountId,
                    trading_account_id: "",
                    centsPerShare: centsPerShare,
                    // rateOrCents === "rate"
                    //   ? centsPerShare
                    //   : row?.cents_per_share,
                    comments: "",
                    is_wip: true,
                    locate_id: 0,
                    quantity: 0,
                    rate: rate,
                    qnty_fill: 0,
                    qnty_req: row.share,
                    cpty: activeClientShortName?.trim(),
                    accrual: (ticker?.price * row.rate * row.share) / 36000,
                    bl: 0,
                    dtc: 0,
                    value: row.share * ticker?.price,
                    tickerPrice: ticker?.price,
                  };

              tempArray.push(tempObj);
            }
          }

          rowIndex++;
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        setExcelLoader(false);
        if (rowsToSkip?.length > 0) {
          const uniqueRowIndex = _.uniq(rowsToSkip);
          setRowsToSkip(uniqueRowIndex);
          setShowSkippedRowPopup(true);
        }
        
        if (tempArray?.length > 0) {
          const rateRegex = /^-?\d{1,3}(\.\d{1,4})?$/;

          const groupedRows = _.groupBy(
            tempArray,
            (row: any) =>
              `${(row.client || "").trim().toLowerCase()}_${(
                row.sec_id ||
                row.ticker ||
                ""
              )
                .trim()
                .toUpperCase()}`
          );

          const mergedRows = _.flatMap(groupedRows, (rows: any[]) => {
            if (!rows.length) return [];

            const results: any[] = [];

            rows.forEach((r) => {
              let qty = Number(r.quantity ?? 0);

              if (qty < 0) qty = 0;

              if (qty === 0 || isNaN(qty)) {
                results.push({
                  ...r,
                  quantity: qty,
                  status: "Error",
                  error_status: "Invalid Quantity",
                });
              }
            });

            const validRows = rows
              .filter((r) => {
                let qty = Number(r.quantity ?? 0);
                if (qty < 0) qty = 0;
                return qty > 0;
              })
              .filter((r) => {
                const rateStr = String(r.rate ?? "").trim();
                return !rateStr || rateRegex.test(rateStr);
              });

            if (validRows.length) {
              const base = { ...validRows[0] };
              const totalQty = _.sumBy(validRows, (r) =>
                Number(r.quantity ?? r.share ?? 0)
              );
              const totalQtyReq = _.sumBy(validRows, (r) =>
                Number(r.qnty_req ?? r.qty_req ?? 0)
              );

              base.quantity = totalQty;
              base.qnty_req = totalQtyReq;
              base.qty_req = totalQtyReq;

              const price = Number(base.tickerPrice) || 0;
              const rate = base.rate ? Number(base.rate) : 0;
              const cps = base.centsPerShare ? Number(base.centsPerShare) : 0;

              base.value = totalQty * price;
              // if (rate > 0) {
              if (rate !== 0) {
                base.accrual = (price * rate * totalQty) / 36000;
              } else if (cps > 0) {
                base.accrual = cps * totalQty;
              } else {
                base.accrual = 0;
              }

              base.status = "Merged";
              results.push(base);
            }

            return results;
          });

          setRowsToUpload(mergedRows);
        }
      }
    } else {
      setExcelLoader(false);
      // setApiExceptionHandler({ isError: true, error: messages.TemplateMessage })
    }
  };

  const onBulkSubmit = () => {
    if (selectedTab === "Pre Borrow") {
      bulkUploadLocates(rowsToUpload, true, false);
    } else if (selectedTab === "Locates" || selectedTab === "Enquiry") {
      bulkUploadLocates(rowsToUpload, false, true);
    }
  };

  const bulkUploadLocates = async (
    rowsToUpload: any,
    isSubmit: boolean,
    isAdd: boolean
  ) => {
    if (rowsToUpload && rowsToUpload?.length > 0) {
      setIsBulkUploadRunning(true);
      try {
        const request = {
          isInquiry: selectedTab === "Enquiry",
          isValidate: false,
          isSubmit: isSubmit,
          isPreborrow: selectedTab === "Pre Borrow",
          locate_src: "UI",
          locateApprovedRequest: rowsToUpload,
        };

        let endpoint = EndPoint.saveOrderRequest;
        if (selectedTab === "Enquiry") {
          endpoint = isAdmin
            ? EndPoint.saveQuoteInquiry
            : EndPoint.sendQuoteInquiry;
        } else {
          if (isAdmin) {
            endpoint =
              isAdmin && isAdd
                ? EndPoint.saveOrderRequest
                : EndPoint.sendOrderRequest;
          } else {
            endpoint = isAdd
              ? EndPoint.saveOrderRequest
              : EndPoint.sendOrderRequest;
          }
        }

        axios.defaults.headers.common = {
          Authorization: `Bearer ${accessToken}`,
        };

        await axios
          .post(
            `${serviceAPIMapping["LOCATEMANAGEMENT-SERVICE"].apiRouteURL}${endpoint}`,
            JSON.stringify(request),
            {
              headers: headers,
            }
          )
          .then((response) => {
            if (response && response?.status === 200) {
              if (selectedTab === "Locates") {
                if (!_.isUndefined(response?.data?.responseEntity)) {
                  insertNewRow?.(response?.data?.responseEntity);
                  const ticker = response?.data?.responseEntity?.find(
                    (t: any) => t?.ticker === tickerDetails?.ticker
                  );
                  if (ticker?.status !== LocateStatus.Rejected) {
                    onTickerChange(ticker?.ticker);
                  }
                } else if (!_.isUndefined(response?.data?.locateResponseList)) {
                  insertNewRow?.(response?.data?.locateResponseList);
                  const ticker = response?.data?.locateResponseList?.find(
                    (t: any) => t?.ticker === tickerDetails?.ticker
                  );
                  if (isAdmin && ticker?.status !== LocateStatus.Rejected) {
                    onTickerChange(ticker?.ticker);
                  }
                }
              }
              props?.onDeselectAll?.();
              //toast.success('Locates saved successfully')
              // selectedTab === "Pre Borrow"
              //   ? refreshPreBorrows?.()
              //   : refreshLocates?.();
            }
          });
      } catch (error: any) {
        if (error?.response?.data?.hasError) {
          swal({
            icon: "error",
            text: `Submit locate is failed with error - "${error?.response?.data?.errorMessage}"`,
            dangerMode: false,
            closeOnClickOutside: false,
          });
        }

        if (selectedTab === "Locates") {
                if (!_.isUndefined(error?.response?.data?.responseEntity)) {
                  insertNewRow?.(error?.response?.data?.responseEntity);
                  const ticker = error?.response?.data?.responseEntity?.find(
                    (t: any) => t?.ticker === tickerDetails?.ticker
                  );
                  if (ticker?.status !== LocateStatus.Rejected) {
                    onTickerChange(ticker?.ticker);
                  }
                } else if (!_.isUndefined(error?.response?.data?.locateResponseList)) {
                  insertNewRow?.(error?.response?.data?.locateResponseList);
                  const ticker = error?.response?.data?.locateResponseList?.find(
                    (t: any) => t?.ticker === tickerDetails?.ticker
                  );
                  if (isAdmin && ticker?.status !== LocateStatus.Rejected) {
                    onTickerChange(ticker?.ticker);
                  }
                }
              }
              props?.onDeselectAll?.();
      } finally {
        setIsBulkUploadRunning(false);
        setExcelFileName("");
        setIsBulkUploadOpen(false);
      }
    }
  };

  function onExcelExport() {
    const spreadsheets = [];

    if (selectedTab === "Locates") {
      spreadsheets.push(
        props?.currentGridRef?.current?.api?.getSheetDataForExcel?.({
          sheetName: selectedTab,
        })!,
        locateMostGridRef?.current?.api?.getSheetDataForExcel?.({
          sheetName: "Most-Located",
        })!,
        locateSupplyGridRef?.current?.api?.getSheetDataForExcel?.({
          sheetName: "Supply",
        })!
      );
    } else {
      spreadsheets.push(
        props?.currentGridRef?.current?.api?.getSheetDataForExcel?.({
          sheetName: selectedTab,
        })
      );
    }

    exportMultipleSheetsAsExcel({
      data: spreadsheets,
      fileName: `${selectedTab}.xlsx`,
    });
  }

  const onRefresh = () => {
    switch (selectedTab) {
      case "Locates": {
        refreshLocates?.();
        break;
      }
      case "Pre Borrow": {
        refreshPreBorrows?.();
        break;
      }
      case "Most Located": {
        refreshMostLocated?.();
        break;
      }
      case "Enquiry": {
        refreshInquiries?.();
        break;
      }
    }
    setDefaultTickerDetails();
    setLastUpdatedDate(moment(new Date()).format("MM/DD/yyyy HH:mm"));
  };

  useEffect(() => {
    setIsRequestSubmitted(false);
    setIsOverrideSubmitted(false);
    setValues(locateStateValueDefault);

    setDefaultTickerDetails();
    setCurrentClient(null);
    setCurrentTicker(null);
    handleInputFocus("client");
    if (
      ((isAdmin && selectedTab !== "Enquiry") || !isAdmin) &&
      globalSearchRef?.current
    )
      globalSearchRef["current"]["value"] = null;
  }, [selectedTab]);

  const onFilterTextChange = _.debounce((event: any) => {
    const filterDataLoan: any = currentGridApi?.setQuickFilter(
      event?.target?.value
    );
    currentGridApi?.setQuickFilter(event?.target?.value);
    currentGridApi?.applyTransaction({
      update: filterDataLoan,
    });
    if (selectedTab === "Locates") {
      const mostLocatedFilter =
        locateMostGridRef?.current?.api?.setQuickFilter?.(event?.target?.value);
      const supplyLocateFilter =
        locateSupplyGridRef?.current?.api?.setQuickFilter?.(
          event?.target?.value
        );

      locateMostGridRef?.current?.api?.applyTransaction({
        update: mostLocatedFilter,
      });

      locateSupplyGridRef?.current?.api?.applyTransaction({
        update: supplyLocateFilter,
      });
    }
  }, 800);

  const onTickerChange = async (changeValue: any, cusip: any = null) => {
    if (changeValue && !_.isEmpty(changeValue)) {
      const request = {
        function_code: "fn_rpt_sl_quote_ticker_cusip",
        function_param: {
          ticker_in: changeValue,
          accountid: accountId,
          cusip_in: cusip,
        },
      };

      try {
        await axios
          .post(
            `${serviceAPIMapping["REPORTING-SERVICE"].apiRouteURL}${EndPoint.reportFn}`,
            request,
            {
              headers: headers,
            }
          )
          .then(async (kpiResponse: any) => {
            if (kpiResponse?.status === 200) {
              const kpiJson = await kpiResponse?.data;
              if (kpiJson && _.isArray(kpiJson) && kpiJson?.length > 0) {
                const ticker = {
                  cusip: kpiJson[0]?.cusip,
                  price: kpiJson[0]?.price,
                  name: kpiJson[0]?.name,
                  ticker: kpiJson[0]?.ticker,
                  lp_rate_out: _.isEmpty(kpiJson[0]?.lp_rate_out)
                    ? ""
                    : kpiJson[0]?.lp_rate_out?.toFixed(4),
                  lp_rate_new: _.isEmpty(kpiJson[0]?.lp_rate_new)
                    ? ""
                    : kpiJson[0]?.lp_rate_new?.toFixed(4),
                  lp_last_avg: _.isEmpty(kpiJson[0]?.lp_rate_last)
                    ? ""
                    : kpiJson[0]?.lp_rate_last?.toFixed(4),
                  isin: kpiJson[0]?.isin,
                  spread: kpiJson[0]?.spread,
                  ss_br_rate: _.isEmpty(kpiJson[0]?.ss_br_rate)
                    ? ""
                    : kpiJson[0]?.ss_br_rate?.toFixed(4),
                  ss_ln_rate: _.isEmpty(kpiJson[0]?.ss_ln_rate)
                    ? ""
                    : kpiJson[0]?.ss_ln_rate?.toFixed(4),
                  ss_locate_rate: _.isEmpty(kpiJson[0]?.ss_locate_rate)
                    ? ""
                    : kpiJson[0]?.ss_locate_rate?.toFixed(4),
                  cents_share: isNaN(kpiJson[0]?.cents_share)
                    ? ""
                    : kpiJson[0]?.cents_share,
                  remaining_qnty:
                    !kpiJson[0]?.remaining_qnty ||
                    (_.isString(kpiJson[0]?.remaining_qnty) &&
                      _.isEmpty(kpiJson[0]?.remaining_qnty))
                      ? 0
                      : kpiJson[0]?.remaining_qnty,
                  isregsho: kpiJson[0]?.isregsho,
                  islocatehold: kpiJson[0]?.islocatehold,
                  avail_date: kpiJson[0]?.avail_date,
                };
                setTickerDetails(ticker);
                if (selectedTab === "Locates") {
                  onCurrentKPITickerChange?.(ticker?.ticker);
                }

                setCPS(ticker?.cents_share);
                setIsCPSEdit(false);
                setIsTickerHoldDisabled(kpiJson[0]?.isregsho);
                setIsTickerHold(kpiJson[0]?.islocatehold);
                setValues((val: any) => {
                  if (
                    _.isEmpty(val?.sec_id) ||
                    val?.sec_id === ticker?.ticker
                  ) {
                    setCurrentTickerDetails(ticker);
                    if (val?.quantity && val?.quantity > 0) {
                      let value = val.quantity * ticker?.price;
                      val.value = isNaN(value) ? "" : value?.toFixed(2);
                    }
                  }

                  return val;
                });
                const locateQty = LocateQtyStatsDefaults?.map(
                  (item: DataType) => {
                    return {
                      ...item,
                      stats: _.get(kpiJson[0], item?.id),
                    };
                  }
                );
                const preBorrowQty = PreBorrowQtyStatsDefaults?.map(
                  (item: DataType) => {
                    return {
                      ...item,
                      stats: _.get(kpiJson[0], item?.id),
                    };
                  }
                );

                const enquiryStats = EnquiryStatsDefaults?.map(
                  (item: DataType) => {
                    return {
                      ...item,
                      stats: _.get(kpiJson[0], item?.id)
                        ? _.get(kpiJson[0], item?.id)
                        : 0,
                    };
                  }
                );

                setEnquiryStats(enquiryStats);

                setLocateQuantities(locateQty);
                setPreBorrowQuantities(preBorrowQty);
              } else {
                setDefaultTickerDetails();
              }
            } else if (kpiResponse?.status === 401) {
              // logout(channel)
            } else {
              setDefaultTickerDetails();
            }
          });
      } catch (err) {
        console.log("Failed to fetch ticker details", err);
      }
    } else {
      setDefaultTickerDetails();
      if (selectedTab === "Locates") {
        onCurrentKPITickerChange?.(null);
      }
    }
  };

  const setDefaultTickerDetails = () => {
    const ticker = {
      cusip: null,
      price: null,
      name: null,
      ticker: null,
      lp_rate_out: null,
      lp_rate_new: null,
      lp_last_avg: null,
      isin: null,
      spread: null,
      ss_br_rate: null,
      ss_ln_rate: null,
      ss_locate_rate: null,
      cents_share: "",
    };
    setTickerDetails(ticker);
    setCPS(ticker?.cents_share);
    setCurrentTickerDetails(ticker);
    setLocateQuantities(LocateQtyStatsDefaults);
    setPreBorrowQuantities(PreBorrowQtyStatsDefaults);
    setIsTickerHoldDisabled(true);
  };

  useEffect(() => {
    if (!validateTermDate(date)) setDefaultTickerDetails();
  }, [date]);

  useEffect(() => {
    if (!_.isEmpty(selectedTicker)) {
      setDefaultTickerDetails();
      onTickerChange(selectedTicker);
      onInputTicker?.("");
      setValues((val: any) => {
        return { ...val, sec_id: "" };
      });
      setCurrentTicker(null);
    }
  }, [selectedTicker]);

  useEffect(() => {
    onToggleTotalRow?.(showTotalRow);
  }, [showTotalRow]);

  useEffect(() => {
    getTickerList();
    if (isAdmin) {
      getClients();
    }

    handleInputFocus("client");
  }, []);

  const handleBulkUploadClose = (event: any, reason: any) => {
    if (reason && (reason === "backdropClick" || reason === "escapeKeyDown")) {
      return;
    }
    setIsBulkUploadOpen(false);
    setRowsToUpload([]);
    setExcelFileName("");
    // setRateOrCents(null);
  };

  const onTickerHoldToggle = (isHold: boolean) => {
    setIsTickerHold(isHold);
    onHoldReleaseTicker(isHold);
  };

  const renderLocatesStats = () => {
    return (
      <div className="d-flex flex-row justify-content-between w-100">
        <div className="d-flex flex-row align-items-center col-10">
          {locateQuantities.map((data: DataType, index: number) => (
            <div
              className={`"d-flex flex-row align-items-center col" ${
                data.id === "remaining_qnty" ? "me-4" : ""
              }`}
              key={index}
            >
              <div className="d-flex flex-row p-1 pb-0 text-nowrap" key={index}>
                <MuiAvatar sx={{ mr: 2, width: 30, height: 30 }}>
                  <Icon icon={data.icon} fontSize="1rem" color={appColor} />
                </MuiAvatar>
                <div className="d-flex flex-column">
                  <div
                    className="sl-quote-kpi-value"
                    style={{ padding: "0rem 0rem" }}
                  >
                    <span>
                      {data.stats && !_.isNaN(data.stats)
                        ? convertToCommas(data.stats)
                        : 0}
                    </span>
                    {data.id === "remaining_qnty" && (
                      <>
                        <IconButton
                          title="Approve"
                          onClick={handleOpenFillPopup}
                          disabled={
                            !(
                              tickerDetails?.ticker?.length > 0 ||
                              tickerDetails?.cusip?.length > 0
                            )
                          }
                          className="ms-1 p-0"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "20px",
                            height: "20px",
                            borderRadius: "4px",
                            cursor: "pointer",
                            marginLeft: "0.5rem",
                            backgroundColor: "#1E355E",
                            verticalAlign: "middle",
                          }}
                        >
                          <AddIcon
                            className={`${
                              !(
                                tickerDetails?.ticker?.length > 0 ||
                                tickerDetails?.cusip?.length > 0
                              )
                                ? "locate-grid-icon-disable"
                                : "locate-grid-icon-replenish"
                            }`}
                          />
                        </IconButton>
                      </>
                    )}
                  </div>
                  <div className="sl-quote-kpi-title">
                    <span>{data.title}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="form-check form-switch d-flex align-items-center justify-content-start text-nowrap col-2">
          <input
            checked={isTickerHold}
            onChange={() => {
              onTickerHoldToggle(!isTickerHold);
            }}
            className={`form-check-input me-2 cursor-pointer ${
              isTickerHoldDisabled ? "cursor-not-allowed" : "cursor-pointer"
            }`}
            type="checkbox"
            role="switch"
            id="tickerHold"
            title="Hold/Release a ticker"
            style={{ fontSize: "large" }}
            disabled={isTickerHoldDisabled}
          />
          <label
            className="form-check-label text-nowrap mb-0 align-self-center mt-1"
            htmlFor="tickerHold"
            style={{ fontSize: "medium", marginLeft: "4px" }}
            title="THold/Release a ticker"
          >
            {isTickerHold ? "Release" : "Hold"}
          </label>
        </div>
      </div>
    );
  };

  const [isFillPopupOpen, setIsFillPopupOpen] = useState(false);
  const [fillForm, setFillForm] = useState({
    lender: "",
    ticker: "",
    quantity: "",
    rate: "",
  });
  const [formErrors, setFormErrors] = useState({
    lender: false,
    quantity: false,
    ticker: false,
    rate: false,
  });

  const validateForm = (): { isValid: boolean; errors: typeof formErrors } => {
    const errors = {
      lender: !fillForm.lender,
      ticker: !fillForm.ticker,
      quantity: !fillForm.quantity,
      rate: false,
    };

    setFormErrors(errors);

    const isValid = !Object.values(errors).some((e) => e);
    return { isValid, errors };
  };

  const [lenderOptions, setLenderOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const handleOpenFillPopup = () => {
    setFillForm({
      lender: "",
      ticker: currentTickerDetails?.ticker ?? "",
      quantity: "",
      rate: "",
    });
    //  setFormErrors({ lender: false, quantity: false, rate: false });
    getLenders();
    setIsFillPopupOpen(true);
  };

  const handleDialogClose = (event: object, reason: string) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    setIsFillPopupOpen(false); // allow closing manually
  };

  const getLenders = async () => {
    try {
      const accountId = window.localStorage.getItem("activeAccountCode");
      const token = window.localStorage.getItem("refreshtoken");

      if (!accountId || !token) {
        setLenderOptions([]);
        return;
      }

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      const baseUrl =
        serviceAPIMapping["SUPPLYMANAGEMENT-SERVICE"]?.apiRouteURL;
      const endpoint = EndPoint.getLenders;

      const url = `${baseUrl}${endpoint}?account_id=${accountId}`;

      const response = await axios.post(url, {}, { headers });

      if (response?.data && Array.isArray(response.data)) {
        const options = response.data.map((lender: any) => ({
          label: lender.shortName.trim(),
          value: lender.lenderId,
        }));

        setLenderOptions(options);
      } else {
        setLenderOptions([]);
      }
    } catch (error) {
      setLenderOptions([]);
    }
  };

  const submitFillData = async () => {
    const { isValid, errors } = validateForm();

    if (!isValid) {
      if (errors.rate) {
        toast.error("Rate cannot be all zeros (e.g. 000.0000)");
      } else {
        toast.error("Please fill in all mandatory fields.");
      }
      return;
    }

    const quantity = Number(fillForm.quantity);

    if (
      !Number.isInteger(quantity) ||
      quantity < 1 ||
      fillForm.quantity.length > 12
    ) {
      toast.error(
        fillForm.quantity.length > 12
          ? "Quantity cannot exceed 12 digits ."
          : "Quantity must be a whole number greater than or equal to 1."
      );
      return;
    }

    const accountId = localStorage.getItem("activeAccountCode");
    const token = localStorage.getItem("refreshtoken");

    if (!token || !accountId) {
      toast.error("Missing account ID or token.");
      return;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const rate = Number(fillForm.rate);
    const value = quantity * rate;

    const data = [
      {
        sec_id: fillForm.ticker,
        qty: quantity,
        value: value,
        rate: rate,
        lender: fillForm.lender,
      },
    ];

    try {
      const baseUrl =
        serviceAPIMapping["SUPPLYMANAGEMENT-SERVICE"]?.apiRouteURL;
      const endpoint = EndPoint.lenderReplenish;
      const url = `${baseUrl}${endpoint}?account_id=${accountId}`;
      const response = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(data),
      });

      const result = await response.text();

      if (response.ok) {
        toast.success("Lender data submitted successfully.");
        onTickerChange(fillForm.ticker);

        setFillForm({
          lender: "",
          ticker: "",
          quantity: "",
          rate: "",
        });

        setIsFillPopupOpen(false);
      } else {
        toast.error(`Submission failed: ${result}`);
      }
    } catch (err) {
      console.error("Submit error:", err);
      toast.error("Error occurred while submitting.");
    }
  };

  const renderPreBorrowStats = () => {
    return preBorrowQuantities.map((data: DataType, index: number) => (
      <div
        className="d-flex"
        key={index}
        style={{
          justifyContent: `${data?.id === "pending_qnty" ? "end" : ""}`,
          paddingLeft: `${
            (index !== 0 && index !== locateQuantities?.length - 1) ?? "0px"
          }`,
          marginLeft: `${index !== 0 ? "4rem" : "0.5rem"}`,
        }}
      >
        <div className="d-flex flex-row p-1 pb-0" key={index}>
          <MuiAvatar sx={{ mr: 2, width: 30, height: 30 }}>
            <Icon icon={data.icon} fontSize="1rem" color={appColor} />
          </MuiAvatar>

          <div className="d-flex flex-column">
            <div
              className="sl-quote-kpi-value"
              style={{ padding: "0rem 0rem" }}
            >
              <span>
                {data.stats && !_.isNaN(data.stats)
                  ? convertToCommas(data.stats)
                  : 0}
              </span>
            </div>
            <div className="sl-quote-kpi-title">
              <span>{data.title}</span>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const renderEnquiryStats = () => {
    return locateQuantities.map((data: DataType, index: number) => (
      <div
        className="d-flex"
        key={index}
        style={{
          justifyContent: `${data?.id == "pending_qnty" ? "end" : ""}`,
          paddingLeft: `${
            (index !== 0 && index !== locateQuantities?.length - 1) ?? "0px"
          }`,
          marginLeft: `${index !== 0 ? "4rem" : "1rem"}`,
        }}
      >
        <div className="d-flex flex-row p-1 pb-0" key={index}>
          <MuiAvatar sx={{ mr: 2, width: 30, height: 30 }}>
            <Icon icon={data.icon} fontSize="1rem" color={appColor} />
          </MuiAvatar>
          <div className="d-flex flex-column">
            <div
              className="sl-quote-kpi-value"
              style={{ padding: "0rem 0rem" }}
            >
              <span>
                {data.stats && !_.isNaN(data.stats)
                  ? convertToCommas(data.stats)
                  : 0}
              </span>
            </div>
            <div className="sl-quote-kpi-title">
              <span>{data.title}</span>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  useEffect(() => {
    if (values?.value > 250000000) {
      showValueValidationAlert();
    }
  }, [values?.value]);

  const showValueValidationAlert = () => {
    swal({
      icon: "warning",
      text: `Contract value entered is bigger than 250M. Do you want to continue?`,
      dangerMode: false,
      closeOnClickOutside: false,
      buttons: ["No", "Yes"],
    }).then((isConfirm: boolean) => {
      if (!isConfirm) {
        setValues((vl: any) => {
          return { ...vl, value: "", quantity: "" };
        });
        handleInputFocus("'quantity'");
      }
    });
  };

  const navigateSLQuote = (ticker: string) => {
    navigate(`/dashboards/sl-quote/${ticker}`);
  };

  const updateCPS = (reqCps?: any) => {
    if (
      (!_.isNull(reqCps) && !isNaN(reqCps) && +reqCps >= 0) ||
      (!_.isEmpty(cps) && !isNaN(+cps) && +cps >= 0)
    ) {
      try {
        let accountId = window.localStorage.getItem("activeAccountCode");
        const date = moment(tickerDetails?.avail_date).format("YYYY-MM-DD");
        const request = [
          {
            ticker: tickerDetails?.ticker,
            cents_share: reqCps ?? cps,
            avail_date: date,
          },
        ];
        const token = window.localStorage.getItem("refreshtoken");
        const header = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        };

        axios
          .post(
            `${serviceAPIMapping["RATEMANAGEMENT-SERVICE"].apiRouteURL}${EndPoint.updateRateDetailsList}?account_id=${accountId}`,
            JSON.stringify(request),
            {
              headers: header,
            }
          )
          .then((response: any) => {
            if (!response) {
              // setOpen(true);
              // setSnackbarMessage(messages.TickerDownMessage);
            } else if (!_.isUndefined(response) && response?.status === 200) {
              setIsCPSEdit(false);
              onTickerChange(tickerDetails?.ticker);
              if (
                response?.data?.message === "Updated Rate change successfully!"
              )
                toast.success("Cents per Share saved successfully");
              else {
                toast.error(response?.data?.message);
              }
            } else if (response?.status === 401) {
              /// TODO: implement proper logout
              //navigate('/signin')
            }
          });
      } catch (err) {
        toast.error("Failed to save Cents per Share");
      } finally {
        // setDoShowFullScreenLoader(false);
      }
    }
  };

  const cpsChangeHandle = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = e.target.value;

    // Allow only numbers + dot
    if (!/^\d*\.?\d*$/.test(val)) return;

    // Restrict to 4 decimal places
    if (val.includes(".")) {
      const [intPart, decimalPart] = val.split(".");
      if (decimalPart.length > 4) {
        val = intPart + "." + decimalPart.slice(0, 4);
      }
    }

    setCPS(val);

    if (parseFloat(val) >= 1) {
      // val = "1";
      setCPS(val);
      swal({
        icon: "warning",
        text: `Cents Per Share entered is greater than or equal to $1, Do you want to Continue? `,
        dangerMode: false,
        closeOnClickOutside: false,
        buttons: ["No", "Yes"],
        className: "swal-confirm-color",
      }).then((isConfirm: any) => {
        if (!_.isNull(isConfirm)) {
          setTimeout(() => {
            updateCPS(val);
          }, 200);
        }
      });
    }
  };

  const handleKeyDown = async (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && parseFloat(cps) >= 0) {
      updateCPS(null);
    }
  };

  const renderTickerDetails = () => {
    return (
      <div className="w-100 sx-md-overflow-x ticker-details-container">
        <div
          className="d-flex flex-row justify-content-between ms-0 row ticker-details-row"
          style={{
            backgroundColor: `${isAdmin ? "#edf2f5" : ""}`,
          }}
        >
          <div
            className={`d-flex flex-row justify-content-start ticker-col ${
              isSmallerDeviceRes
                ? "col-6"
                : "ps-2 col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4"
            }`}
          >
            <Typography color={appColor} fontSize={"1rem"} variant="h6">
              Name:
            </Typography>
            <Typography
              className="ms-2 ticker-text"
              fontSize={"1rem"}
              title={tickerDetails?.name}
            >
              {tickerDetails?.name
                ? tickerDetails?.name?.length > 30
                  ? tickerDetails?.name?.substring(0, 27) + "..."
                  : tickerDetails?.name
                : ""}{" "}
            </Typography>
          </div>

          <div
            className={`d-flex flex-row justify-content-start ticker-col ${
              isSmallerDeviceRes ? "col-6" : "ps-2 col"
            }`}
          >
            <Typography color={appColor} fontSize={"1rem"} variant="h6">
              Cusip:
            </Typography>
            <Typography className="ms-2 ticker-text" fontSize={"1rem"}>
              {tickerDetails?.cusip || ""}
            </Typography>
          </div>

          <div
            className={`d-flex flex-row justify-content-start ticker-col ${
              isSmallerDeviceRes ? "col-6" : "ps-2 col"
            }`}
          >
            <Typography color={appColor} fontSize={"1rem"} variant="h6">
              Ticker:
            </Typography>
            <Typography
              className="ms-2 cursor-pointer ticker-link"
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                color: "rgb(13, 110, 253)",
              }}
              fontSize={"1rem"}
              onClick={() => navigateSLQuote(tickerDetails?.ticker)}
            >
              {tickerDetails?.ticker || ""}
            </Typography>
          </div>

          <div
            className={`d-flex flex-row justify-content-start ticker-col ${
              isSmallerDeviceRes ? "col-6" : "ps-2 col"
            }`}
          >
            <Typography color={appColor} fontSize={"1rem"} variant="h6">
              Price:
            </Typography>
            <Typography className="ms-2 ticker-text" fontSize={"1rem"}>
              {tickerDetails?.price
                ? formatNumber.format(tickerDetails?.price)
                : ""}
            </Typography>
          </div>
          {isAdmin && selectedTab === "Locates" && (
            <>
              <div
                className={` d-flex flex-row justify-content-start align-items-start ${
                  isSmallerDeviceRes ? "col-6" : "ps-2 col-2"
                }`}
              >
                <Typography
                  className="me-1"
                  color={appColor}
                  fontSize={"0.8rem"}
                  variant="h6"
                  title={"Cents per share($)"}
                >
                  CPS:{" "}
                </Typography>
                {!isCPSEdit && (
                  <>
                    <Typography
                      className="ms-2"
                      fontSize={"0.8rem"}
                    >{`${cps}`}</Typography>
                  </>
                )}

                {isCPSEdit &&
                  hasAccess([
                    `${pageConstant.RATES_DASHBOARD}_RW`,
                    `${pageConstant.RATES_DASHBOARD}_ADMIN`,
                  ]) && (
                    <>
                      <input
                        id="centsPerShareUpdate"
                        type="number"
                        value={cps}
                        onChange={(e) => {
                          cpsChangeHandle(e);
                          // setCPS(e?.target?.value);
                        }}
                        step={0.01}
                        style={{
                          height: "1.5rem",
                          width: "80%",
                          border: "none",
                        }}
                        onKeyDown={handleKeyDown}
                      ></input>
                    </>
                  )}
                {hasAccess([
                  `${pageConstant.RATES_DASHBOARD}_RW`,
                  `${pageConstant.RATES_DASHBOARD}_ADMIN`,
                ]) && (
                  <>
                    <span className="d-flex flex-row align-self-start ms-1">
                      {isCPSEdit && (
                        <>
                          <IconButton
                            className="p-0"
                            onClick={() => updateCPS(null)}
                          >
                            <DoneIcon fontSize="small"></DoneIcon>
                          </IconButton>
                          <IconButton
                            className="p-0"
                            onClick={() => {
                              setIsCPSEdit(false);
                              setCPS(tickerDetails?.cents_share);
                            }}
                          >
                            <ClearIcon fontSize="small"></ClearIcon>
                          </IconButton>
                        </>
                      )}
                      {!isCPSEdit &&
                        !_.isNaN(tickerDetails?.cents_share) &&
                        tickerDetails?.cents_share !== "" && (
                          <>
                            <IconButton
                              className="p-0"
                              onClick={() => {
                                setIsCPSEdit(true);
                              }}
                            >
                              <EditIcon fontSize="small"></EditIcon>
                            </IconButton>
                          </>
                        )}
                    </span>
                  </>
                )}
              </div>
            </>
          )}

          <div
            className={`d-flex flex-row justify-content-start ticker-col ${
              isSmallerDeviceRes ? "col-6" : "col"
            }`}
          >
            <Typography color={appColor} fontSize={"1rem"} variant="h6">
              Regsho:
            </Typography>
            <Typography
              className="ms-2 ticker-text"
              fontSize={"1rem"}
              color={tickerDetails?.isregsho ? "red" : ""}
            >
              {tickerDetails?.isregsho ? "Yes" : "No"}
            </Typography>
          </div>
        </div>

        <div className="row ms-0 admin-stats-row">
          {isAdmin && (
            <div className="d-flex flex-row mb-0 justify-content-between">
              {selectedTab === "Enquiry" && (
                <div className="d-flex flex-row w-100">
                  {renderEnquiryStats()}
                </div>
              )}
              {selectedTab === "Locates" && (
                <div className="d-flex flex-row w-100">
                  {renderLocatesStats()}
                </div>
              )}
              {selectedTab === "Pre Borrow" && (
                <div className="d-flex flex-row w-100">
                  {renderPreBorrowStats()}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  const onRatesBlur = () => {
    if (values?.rate && (values?.rate > 6 || values?.rate < -999.9999)) {
      showRatesAlert();
    } else if (values?.rate && !_.isEmpty(values?.rate)) {
      handleInputFocus("comments");
    }

    setValues({
      ...values,
      rate: values?.rate ? +(+values?.rate)?.toFixed(4) : values?.rate,
    });
  };

  const onCentsPerShareBlur = () => {
    if (values?.centsPerShare >= 1) {
      showCentsPerShareAlert();
    }
  };

  const onValueBlur = () => {
    if (!_.isNaN(values?.value)) {
      setValues((val) => {
        return {
          ...val,
          value: (+val?.value)?.toFixed(2),
        };
      });
    }
  };

  const getClients = async () => {
    try {
      await axios
        .get(
          `${serviceAPIMapping["AUTH-SERVICE"].apiRouteURL}${EndPoint.authBase}${EndPoint.getClientEntityDetails}`,
          {
            headers: headers,
          }
        )
        .then((response: any) => {
          if (response?.status === 200) {
            const locateClients = _.uniqBy(response?.data, "clientName");
            const uniqueClients = _.filter(locateClients, [
              "clientType",
              "Locate",
            ]);
            setClientOptions(uniqueClients);
          }
        });
    } catch (err) {}
  };

  const customFilterClient = (option: any, searchText: any) => {
    if (
      option.data.shortName
        .toLowerCase()
        .startsWith(searchText.toLowerCase()) ||
      option.data.shortName.toLowerCase().startsWith(searchText.toLowerCase())
    ) {
      return true;
    } else {
      return false;
    }
  };

  const customClientSelectStyles = {
    option: (provided: any, state: any) => ({
      ...provided,
      color: "#000",
      fontSize: "0.7rem",
      backgroundColor: state.isFocused ? "#EAECEF" : null,
      cursor: "pointer",
    }),
    control: (base: any) => ({
      ...base,
      fontSize: "0.8rem",
      minWidth: "8rem",
      maxWidth: "8rem",
      marginRight: "0.5rem",
      borderColor:
        (isRequestSubmitted || isOverrideSubmitted) &&
        (_.isNull(currentClient) || _.isEmpty(currentClient))
          ? "red"
          : "#EAECEF",
      ":hover": {
        borderColor:
          (isRequestSubmitted || isOverrideSubmitted) &&
          (_.isNull(currentClient) || _.isEmpty(currentClient))
            ? "red"
            : "#EAECEF",
      },
    }),
    valueContainer: (base: any) => ({
      ...base,
      height: "2.4rem",
    }),
    indicatorsContainer: (base: any) => ({
      ...base,
    }),
    menu: (provided: any) => ({
      ...provided,
      width: 150,
      backgroundColor: "#fff",
    }),
    input: (provided: any) => ({
      ...provided,
      height: "2rem",
    }),
  };

  const customTickerStyles = {
    option: (provided: any, state: any) => ({
      ...provided,
      color: "#000",
      fontSize: "0.7rem",
      backgroundColor: state.isFocused ? "#EAECEF" : null,
      cursor: "pointer",
    }),
    control: (base: any) => ({
      ...base,
      fontSize: "0.8rem",
      minWidth: "8rem",
      maxWidth: "8rem",
      marginRight: "0.5rem",
      borderColor:
        (isRequestSubmitted || isOverrideSubmitted) &&
        (_.isNull(currentTicker) || _.isEmpty(currentTicker))
          ? "red"
          : "#EAECEF",
      ":hover": {
        borderColor:
          (isRequestSubmitted || isOverrideSubmitted) &&
          (_.isNull(currentTicker) || _.isEmpty(currentTicker))
            ? "red"
            : "#EAECEF",
      },
    }),
    valueContainer: (base: any) => ({
      ...base,
      height: "2.4rem",
    }),
    indicatorsContainer: (base: any) => ({
      ...base,
    }),
    singleValue: (base: any) => ({
      ...base,
      marginTop: "10px",
    }),
    menu: (provided: any) => ({
      ...provided,
      width: 300,
      backgroundColor: "#fff",
    }),
    input: (provided: any) => ({
      ...provided,
      height: "2rem",
    }),
  };

  const customFilterTicker = (option: any, searchText: any) => {
    if (
      option &&
      ((option.data.cusip &&
        option.data.cusip.toLowerCase().startsWith(searchText.toLowerCase())) ||
        (option.data.ticker &&
          option.data.ticker
            .toLowerCase()
            .startsWith(searchText.toLowerCase())))
    ) {
      return true;
    } else if (searchText && !option.data.cusip && !option.data.ticker) {
      return true;
    } else {
      return false;
    }
  };

  const preventMinus = (e: any) => {
    if (
      e.code === constants.NumpadSubtract ||
      e.code === constants.Minus ||
      e.code === constants.Period
    ) {
      e.preventDefault();
    }
  };

  const handleInputFocus = (focus: string) => {
    switch (focus) {
      case "client":
        clientRef?.current?.focus();
        break;

      case "ticker":
        tickerRef?.current?.focus();
        break;

      case "quantity":
        quantityRef?.current?.focus();
        break;

      case "rate":
        rateRef?.current?.focus();
        break;

      case "centsPerShare":
        centsPerShareRef?.current?.focus();
        break;

      case "comments":
        commentsRef?.current?.focus();
        break;

      case "value":
        valueRef?.current?.focus();
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    const hasAcc = hasAccess([
      `${pageConstant?.LOCATE_DASHBOARD}_ADMIN`,
      `${pageConstant?.LOCATE_DASHBOARD}_RW`,
      `${pageConstant?.LOCATE_CLIENT}_ADMIN`,
      `${pageConstant?.LOCATE_CLIENT}_RW`,
    ]);
    if (selectedRows && _.isArray(selectedRows) && !_.isEmpty(selectedRows)) {
      if (isAdmin) {
        const selec = JSON.parse(JSON.stringify([...selectedRows]));
        const rows = [...selec]?.map((r: any) => {
          return {
            batch: r?.batch,
            client: r?.cpty,
            date: "",
            filename: "",
            qty_req: r?.request_quantity,
            rate_req: r?.rebate,
            sec_id: r?.ticker,
            sec_id_type: "T",
            sm_id: "",
            updatedtime: "",
            user_id: userName,
            account_id: accountId,
            trading_account_id: "",
            centsPerShare: r?.centpershare,
            comments: values?.comments,
            is_wip: false,
            locate_id: r?.locate_id,
            quantity: r?.request_quantity,
            rate: r?.rebate,
            qnty_fill: r?.approved_quantity,
            qnty_req: r?.request_quantity,
            cpty: isAdmin
              ? values?.client?.trim()
              : activeClientShortName?.trim(),
            // accrual: _.isNaN(accrual) ? 0 : accrual,
            bl: 0,
            dtc: 0,
            value: values?.value,

            locate_type: selectedTab === "Enquiry" ? "INQUIRY" : "LOCATE",
            tickerPrice: r?.price,
            qnty_appr: r?.approved_quantity,
          };
        });

        setRowsToSubmit(rows);
        const pendingRows = selectedRows?.filter(
          (r: any) =>
            r?.status === LocateStatus.Pending &&
            !r?.hasError &&
            r?.isRowChanged
        );
        const newRows = selectedRows?.filter(
          (r: any) => r?.status === LocateStatus.New
        );
        const rejectedRows = selectedRows?.filter(
          (r: any) =>
            r?.status === LocateStatus.Rejected &&
            !r?.hasError &&
            r?.isRowChanged
        );
        const approvedRows = selectedRows?.filter(
          (r: any) =>
            (r?.status === LocateStatus.Approved ||
              r?.status === LocateStatus.Topup) &&
            !r?.hasError &&
            r?.isRowChanged
        );

        const partialRows = selectedRows?.filter(
          (r: any) =>
            r?.status === LocateStatus.Partial &&
            !r?.hasError &&
            r?.isRowChanged
        );
        const errorRows = selectedRows?.filter((r: any) => r?.hasError);
        const isAppr =
          (pendingRows?.length > 0 || rejectedRows?.length > 0) &&
          errorRows?.length === 0 &&
          newRows?.length === 0 &&
          approvedRows?.length === 0 &&
          partialRows?.length === 0;
        setIsMultiApproveDisable(
          !isAppr ||
            !hasAcc ||
            (selectedTab === "Pre Borrow" ? !isAdmin : false)
        );

        const isRej =
          pendingRows?.length > 0 &&
          errorRows?.length === 0 &&
          rejectedRows?.length === 0 &&
          newRows?.length === 0 &&
          approvedRows?.length === 0 &&
          partialRows?.length === 0;
        setIsMultiRejectDisable(
          !isRej || !hasAcc || (selectedTab === "Pre Borrow" ? !isAdmin : false)
        );

        const isNewUpdatedRows =
          newRows?.filter((r: any) => !r?.hasError && r?.isRowChanged)?.length >
          0;
        const isSave =
          (approvedRows?.length > 0 || isNewUpdatedRows) &&
          errorRows?.length === 0 &&
          rejectedRows?.length === 0 &&
          pendingRows?.length === 0 &&
          partialRows?.length === 0;
        setIsMultiSaveDisable(
          !isSave ||
            !hasAcc ||
            (selectedTab === "Pre Borrow" ? !isAdmin : false)
        );

        const isTopup =
          selectedRows?.filter((r: any) => r?.status !== LocateStatus.New)
            ?.length > 0;
        setIsTopupRequestDisable(
          isTopup ||
            !hasAcc ||
            (selectedTab === "Pre Borrow" ? !isAdmin : false)
        );

        const isClear =
          selectedRows?.filter(
            (r: any) =>
              r?.is_wip &&
              (r?.status === LocateStatus.New ||
                r?.status === LocateStatus.Error)
          )?.length > 0;

        const notWIPRec =
          selectedRows?.filter(
            (r: any) =>
              !r?.is_wip &&
              (r?.status !== LocateStatus.New ||
                r?.status !== LocateStatus.Error)
          )?.length > 0;

        setIsClearDisable(!isClear || !hasAcc || notWIPRec);
      } else {
        const rows = selectedRows?.map((r: any) => {
          return {
            batch: r?.batch,
            client: r.cpty,
            date: "",
            filename: "",
            quantity: r.request_quantity,
            rate: r?.rebate,
            sec_id: r.ticker,
            sec_id_type: "T",
            sm_id: "",
            updatedtime: "",
            user_id: userName,
            account_id: accountId,
            centsPerShare: r?.centpershare,
            tickerPrice: r?.price,
            locate_type: selectedTab === "Enquiry" ? "INQUIRY" : "LOCATE",
            trading_account_id: "",
            locate_id: r?.locate_id,
            qty_req: r.request_quantity,
            rate_req: r?.rebate,
            comments: values?.comments,
            is_wip: false,
            qnty_fill: 0,
            qnty_req: r.request_quantity,
            cpty: isAdmin
              ? values?.client?.trim()
              : activeClientShortName?.trim(),
            bl: 0,
            dtc: 0,
            value: values?.value,
            qnty_appr: 0,
          };
        });
        setRowsToSubmit(rows);
      }
    } else {
      setRowsToSubmit(selectedRows);

      setIsMultiApproveDisable(true);
      setIsMultiRejectDisable(true);
      setIsMultiSaveDisable(true);
      setIsTopupRequestDisable(true);
      setIsClearDisable(true);
    }
  }, [selectedRows]);

  useEffect(() => {
    // Function to handle the resize event
    function handleResize() {
      setIsSmallerDeviceRes(window.innerWidth <= 992);
      setIsSmallersetIs14to16Res(
        window?.innerWidth >= 1400 && window?.innerWidth <= 1700
      );
    }
    // Add the event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (
      inquiryLocateRequest &&
      !_.isNull(inquiryLocateRequest) &&
      !_.isEmpty(inquiryLocateRequest) &&
      selectedTab === "Enquiry"
    ) {
      const ticker = tickerListMap?.get(
        inquiryLocateRequest?.ticker?.toUpperCase()
      );
      const accrual =
        (inquiryLocateRequest?.request_quantity *
          ticker?.price *
          +inquiryLocateRequest?.rebate) /
        36000;

      const sendRequest = {
        isInquiry: false,
        isValidate: true,
        isSubmit: true,
        isPreborrow: inquiryLocateRequest?.isPreBorrow,
        locate_src: "UI",
        locateApprovedRequest: [
          {
            batch: null,
            client: inquiryLocateRequest?.cpty,
            date: "",
            filename: "",
            qty_req: inquiryLocateRequest?.request_quantity,
            rate_req: inquiryLocateRequest?.rebate,
            sec_id: inquiryLocateRequest?.ticker,
            sec_id_type: "T",
            sm_id: "",
            updatedtime: "",
            user_id: userName,
            account_id: accountId,
            trading_account_id: inquiryLocateRequest?.trading_account_id,
            centsPerShare: inquiryLocateRequest?.centpershare,
            comments: inquiryLocateRequest?.comments,
            is_wip: false,
            locate_id: 0,
            quantity: inquiryLocateRequest?.request_quantity,
            rate: inquiryLocateRequest?.rebate,
            qnty_fill: 0,
            qnty_req: inquiryLocateRequest?.request_quantity,
            cpty: inquiryLocateRequest?.cpty?.trim(),
            accrual: accrual,
            bl: 0,
            dtc: 0,
            value: inquiryLocateRequest?.request_quantity * ticker?.price,
          },
        ],
      };

      const saveRequest = {
        isInquiry: false,
        isValidate: true,
        isSubmit: true,
        isPreborrow: inquiryLocateRequest?.isPreBorrow,
        locate_src: "UI",

        locateApprovedRequest: [
          {
            batch: null,
            cpty: inquiryLocateRequest?.cpty?.trim(),
            client: inquiryLocateRequest?.cpty,
            date: "",
            filename: "",
            qty_req: inquiryLocateRequest?.request_quantity,
            rate_req: inquiryLocateRequest?.rebate,
            sec_id: inquiryLocateRequest.ticker,
            sec_id_type: "T",
            sm_id: "",
            updatedtime: "",
            user_id: userName,
            account_id: accountId,
            trading_account_id: "",
            centsPerShare: inquiryLocateRequest?.centpershare,
            comments: inquiryLocateRequest?.comments,
            is_wip: false,
            locate_id: 0,
            quantity: inquiryLocateRequest?.request_quantity,
            rate: inquiryLocateRequest?.rebate,
            qnty_fill: 0,
            qnty_req: inquiryLocateRequest?.request_quantity,
            accrual: accrual,
            bl: 0,
            dtc: 0,
            value: inquiryLocateRequest?.request_quantity * ticker?.price,
          },
        ],
      };

      submitLocate(isAdmin ? saveRequest : sendRequest, false, true);
    }
  }, [inquiryLocateRequest]);

  useEffect(() => {
    setStatusFilter({
      isNewFilterActive: false,
      isApprovedFilterActive: false,
      isTopupFilterActive: false,
      isRejectedFilterActive: false,
      isPendingFilterActive: false,
      isPartialFilterActive: false,
    });
    onResetFilter?.(isResetFilter);
    setIsUIFilterActive(false);
    setIsFileFilterActive(false);
    setIsFixFilterActive(false);
  }, [isResetFilter]);

  const onUIFilter = () => {
    setIsUIFilterActive(!isUIFilterActive);
  };

  const onFileFilter = () => {
    setIsFileFilterActive(!isFileFilterActive);
  };

  const onFixFilter = () => {
    setIsFixFilterActive(!isFixFilterActive);
  };

  useEffect(() => {
    let filters = {
      isUIFilterActive: isUIFilterActive,
      isFileFilterActive: isFileFilterActive,
      isFixFilterActive: isFixFilterActive,
    };
    applyLocateSourceFilter?.(filters);
  }, [isUIFilterActive, isFileFilterActive, isFixFilterActive]);

  useEffect(() => {
    applyLocateStatusFilter?.(statusFilter);
  }, [statusFilter]);

  const onResetFilters = () => {
    setIsResetFilter(!isResetFilter);
    setValues({
      trading_account_id: "",
      client:
        !isAdmin && !_.isUndefined(activeClient) ? activeClient ?? "" : "",
      sec_id: "",
      quantity: "",
      rate: "",
      centsPerShare: "",
      comments: "",
      value: "",
    });
    setCurrentTicker(null);
    onInputTicker?.("");
    onTickerChange(undefined, null);
    setCurrentClient(null);
  };

  const onLocatesClear = async () => {
    if (selectedTab === "Enquiry" && isAdmin) {
      onClearWorkbook?.();
    } else {
      const locateIdList: any[] = [];
      selectedRows?.forEach((locate: any) => {
        const id = _.get(locate, "locate_id");
        locateIdList.push(id);
      });

      if (locateIdList?.length > 0) {
        try {
          setIsBulkUploadRunning(true);
          const request = {
            locateIds: locateIdList,
          };
          await axios
            .post(
              `${serviceAPIMapping["LOCATEMANAGEMENT-SERVICE"].apiRouteURL}${EndPoint.clearLocateRecords}`,
              request,
              {
                headers: headers,
              }
            )
            .then(async (kpiResponse: any) => {
              if (kpiResponse?.status === 200) {
                refreshLocates?.();
              }
            });
        } catch (error: any) {
          swal({
            icon: "error",
            text: `Clear locate(s) is failed with response status - ${error?.response?.status} error - ${error?.message}`,
            dangerMode: false,
            closeOnClickOutside: false,
          });
        } finally {
          setIsBulkUploadRunning(false);
        }
      }
    }
  };
  const onMultiLocateUpdate = (isSaveAction?: boolean, status?: string) => {
    const rows = [...selectedRows]?.filter((r: any) => {
      if (r?.hasError) return false;
      if (isSaveAction) {
        return r?.isRowChanged || r?.status === LocateStatus.Rejected;
      }

      return r?.isRowChanged || r?.status === LocateStatus.Rejected;
    });
    const requestRows = [...rows]?.map((r: any) => ({
      locate_id: r?.locate_id,
      rebate: r?.rebate,
      fee: r?.fee,
      centpershare: r?.centpershare,
      request_quantity: r?.request_quantity,
      username: r?.username,
      action_status: isSaveAction
        ? r?.status
        : status === LocateStatus.Approved
        ? r?.approved_quantity < r?.request_quantity
          ? LocateStatus.Partial
          : status
        : status,
      comments:
        status === LocateStatus.Approved ||
        status === LocateStatus.Topup ||
        status === LocateStatus.Partial
          ? ""
          : r?.comments,
      qty_appr: r?.approved_quantity,
    }));

    if (requestRows.length === 0) {
      swal({
        icon: "warning",
        text: `No valid rows to update`,
        dangerMode: false,
        closeOnClickOutside: false,
      });
      return;
    }

    if (isSaveAction) {
      onLocatesUpdate(requestRows);
    } else {
      const errorRows = requestRows?.filter((r: any) => r?.hasError);
      if (errorRows?.length > 0) {
        swal({
          icon: "warning",
          text: `Some of the rows are not submittable`,
          dangerMode: false,
          closeOnClickOutside: false,
        });
      } else {
        onLocatesUpdate(requestRows);
      }
    }
  };

  const onLocatesUpdate = async (request: any) => {
    try {
      const token = window.localStorage.getItem("refreshtoken");

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      await axios
        .post(
          `${serviceAPIMapping["LOCATEMANAGEMENT-SERVICE"].apiRouteURL}${EndPoint.updateLocateApproved}`,
          JSON.stringify([...request]),
          {
            headers: headers,
          }
        )
        .then(async (response: any) => {
          if (response?.status === 200) {
            const ticker = response?.data?.responseEntity?.find(
              (t: any) => t?.ticker === tickerDetails?.ticker
            );
            if (isAdmin && ticker?.status !== LocateStatus.Rejected) {
              onTickerChange(ticker?.ticker);
            }
            props?.onDeselectAll?.();
          } else if (response?.status === 401) {
            //logout(channel)
          }
        });
    } catch (error: any) {
      if (error?.response?.data?.hasError) {
        swal({
          icon: "error",
          text: `Update locate is failed with error - "${error?.response?.data?.errorMessage}"`,
          dangerMode: false,
          closeOnClickOutside: false,
        });

        const ticker = error?.response?.data?.responseEntity?.find(
              (t: any) => t?.ticker === tickerDetails?.ticker
            );
            if (isAdmin && ticker?.status !== LocateStatus.Rejected) {
              onTickerChange(ticker?.ticker);
            }
            props?.onDeselectAll?.();
      }
    } finally {
    }
  };

  const onShowTotalToggle = () => {
    setShowTotalRow(!showTotalRow);
  };

  const onHoldReleaseTicker = async (isHold?: boolean) => {
    try {
      const token = window.localStorage.getItem("refreshtoken");
      const request = {
        tickers: [currentTickerDetails?.ticker],
        isHold: isHold,
      };
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      await axios
        .post(
          `${serviceAPIMapping["LOCATEMANAGEMENT-SERVICE"].apiRouteURL}${EndPoint.holdReleaseAvailableLocate}`,
          JSON.stringify(request),
          {
            headers: headers,
          }
        )
        .then(async (response: any) => {
          if (response?.status === 200) {
            toast.success(
              `${
                isHold
                  ? "Ticker kept on hold for locate auto approval"
                  : "Ticker released"
              }`
            );
          } else if (response?.status === 401) {
            //logout(channel)
          }
        });
    } catch (err) {
      console.log(err);
    } finally {
    }
  };

  useEffect(() => {
    if (tickerDetails?.ticker) {
      onTickerChange(tickerDetails?.ticker);
    }
  }, [isRefreshTickerKPI]);

  return (
    <>
      {(excelLoader || isBulkUploadRunning) && <SpinnerFullScreen />}
      <div className="div-wrapper-1">
        <div
          className="align-items-center pt-0 div-wrapper-2"
          style={{ backgroundColor: "#f0f8ff78" }}
        >
          {((selectedTab === "Enquiry" && !isAdmin) ||
            selectedTab === "Locates" ||
            selectedTab === "Pre Borrow") && (
            <div className="row pt-0 div-wrapper-3">
              <div
                className={`d-flex flex-row ps-3 align-items-center sm-md-overflow-x div-wrapper-4 ${
                  is14to16Res
                    ? "col-12"
                    : "col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6 "
                } ${isSmallerDeviceRes ? "row" : ""}`}
              >
                {isAdmin && (
                  <div
                    className={`${
                      isSmallerDeviceRes ? "col-6" : ""
                    } div-wrapper-5`}
                  >
                    <Select
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                        MenuList: WindowedMenuList,
                      }}
                      tabIndex={0}
                      onChange={(value: any) => {
                        setValues({ ...values, client: value?.shortName });
                        setCurrentClient(value);
                        handleInputFocus("ticker");
                      }}
                      placeholder="Client"
                      filterOption={customFilterClient}
                      ref={clientRef}
                      menuShouldScrollIntoView={true}
                      getOptionLabel={(option: any) => option.shortName}
                      getOptionValue={(option: any) => option.shortName}
                      options={clientOptions}
                      styles={customClientSelectStyles}
                      value={currentClient}
                      id="client"
                    />
                  </div>
                )}

                <div
                  className={`${
                    isSmallerDeviceRes ? "col-6" : ""
                  } div-wrapper-6`}
                >
                  <CreatableSelect
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null,
                      MenuList: WindowedMenuList,
                    }}
                    tabIndex={0}
                    onChange={(value: any) => {
                      if (values?.rate && !_.isNaN(values?.rate)) {
                        const centsPerShare = +(
                          (value?.price * +values?.rate) /
                          36000
                        )?.toFixed(4);
                        setValues({
                          ...values,
                          centsPerShare: Math.abs(centsPerShare),
                          sec_id: value?.ticker,
                        });
                      } else {
                        setValues({ ...values, sec_id: value?.ticker });
                      }

                      setCurrentTicker(value);
                      handleInputFocus("quantity");
                      onTickerChange(value?.ticker, value?.cusip);
                      onInputTicker?.(value?.ticker);
                    }}
                    placeholder="Ticker"
                    filterOption={customFilterTicker}
                    ref={tickerRef}
                    menuShouldScrollIntoView={true}
                    getOptionLabel={(option: any) => option.ticker}
                    getOptionValue={(option: any) => option.ticker}
                    formatOptionLabel={formatOptionLabel}
                    options={secmasterList}
                    styles={customTickerStyles}
                    value={currentTicker}
                    isClearable={true}
                    id="sec_id"
                    onCreateOption={(value: any) => {
                      const ticker = {
                        label: value?.toUpperCase(),
                        value: value?.toUpperCase(),
                        isNewTicker: true,
                      };
                      setCurrentTicker(ticker);
                      setValues({ ...values, sec_id: ticker?.label });
                      setTickerDetails(ticker);
                      setEnquiryStats(EnquiryStatsDefaults);
                      setLocateQuantities(LocateQtyStatsDefaults);
                      setPreBorrowQuantities(PreBorrowQtyStatsDefaults);
                    }}
                  />
                </div>

                <div
                  className={`${
                    isSmallerDeviceRes ? "col-6 mt-2" : isAdmin ? "" : ""
                  } div-wrapper-7`}
                >
                  <TextField
                    size="small"
                    className="me-1"
                    onChange={handleChange("quantity")}
                    value={values.quantity}
                    id="share"
                    label="Share"
                    type="number"
                    inputProps={{ min: 0 }}
                    error={
                      (isRequestSubmitted ||
                        isOverrideSubmitted ||
                        values.quantity > quantityErrorLimit) &&
                      (!values.quantity || values.quantity > quantityErrorLimit)
                    }
                    InputLabelProps={{ shrink: true }}
                    onKeyPress={preventMinus}
                    onBlur={onQtyBlur}
                    inputRef={quantityRef}
                  />
                </div>

                <div
                  className={`${
                    isSmallerDeviceRes ? "col-6 mt-2" : isAdmin ? "" : ""
                  } div-wrapper-8`}
                >
                  <TextField
                    size="small"
                    className="me-1"
                    onChange={handleChange("rate")}
                    value={values.rate}
                    id="rate"
                    label="Rate"
                    type="number"
                    error={
                      isOverrideSubmitted &&
                      (!values?.rate ||
                        (_.isString(values?.rate) && _.isEmpty(values?.rate)))
                    }
                    onBlur={onRatesBlur}
                    InputLabelProps={{ shrink: true }}
                    inputRef={rateRef}
                  />
                </div>

                <div
                  className={`${
                    isSmallerDeviceRes ? "col-6 mt-2" : isAdmin ? "" : ""
                  } div-wrapper-9`}
                >
                  <TextField
                    size="small"
                    className="me-1"
                    onChange={handleChange("centsPerShare")}
                    value={values.centsPerShare}
                    id="centsPerShare"
                    label="Cents Per Share"
                    type="number"
                    error={isOverrideSubmitted && !isCentsPerShareValid()}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{ inputProps: { min: 0 } }}
                    onBlur={onCentsPerShareBlur}
                    inputRef={centsPerShareRef}
                  />
                </div>

                {selectedTab === "Locates" && (
                  <div
                    className={`${
                      isSmallerDeviceRes
                        ? "col-6 mt-2"
                        : isAdmin
                        ? "me-1"
                        : "me-1"
                    } div-wrapper-10`}
                  >
                    <TextField
                      size="small"
                      onChange={(e) =>
                        setValues({ ...values, comments: e?.target?.value })
                      }
                      value={values.comments}
                      id="comments"
                      label="Comments"
                      type="text"
                      error={
                        isOverrideSubmitted &&
                        currentTickerDetails &&
                        currentTickerDetails?.remaining_qnty <= 0 &&
                        _.isEmpty(values.comments)
                      }
                      InputLabelProps={{ shrink: true }}
                      inputRef={commentsRef}
                    />
                  </div>
                )}
                {selectedTab === "Enquiry" && (
                  <Button
                    size="medium"
                    className="ms-2"
                    variant="contained"
                    onClick={() => {
                      onSubmitLocate(true, false, false);
                    }}
                    disabled={
                      !hasAccess([
                        `${pageConstant?.LOCATE_DASHBOARD}_ADMIN`,
                        `${pageConstant?.LOCATE_DASHBOARD}_RW`,
                        `${pageConstant?.LOCATE_CLIENT}_ADMIN`,
                        `${pageConstant?.LOCATE_CLIENT}_RW`,
                      ])
                    }
                    style={{
                      backgroundColor: hasAccess([
                        `${pageConstant?.LOCATE_DASHBOARD}_ADMIN`,
                        `${pageConstant?.LOCATE_DASHBOARD}_RW`,
                        `${pageConstant?.LOCATE_CLIENT}_ADMIN`,
                        `${pageConstant?.LOCATE_CLIENT}_RW`,
                      ])
                        ? appColor
                        : "",
                      color: "white",
                    }}
                  >
                    Inquiry
                  </Button>
                )}

                {selectedTab === "Locates" && (
                  <>
                    {isAdmin && (
                      <Button
                        size="small"
                        onClick={() => {
                          onSubmitLocate(false, false, true);
                        }}
                        className={`ms-2 p-2 px-4 ${
                          isSmallerDeviceRes ? "col-4 mt-2" : "text-nowrap p-2"
                        }`}
                        variant="contained"
                        disabled={
                          !hasAccess([
                            `${pageConstant?.LOCATE_DASHBOARD}_ADMIN`,
                            `${pageConstant?.LOCATE_DASHBOARD}_RW`,
                          ])
                        }
                        style={{
                          backgroundColor: hasAccess([
                            `${pageConstant?.LOCATE_DASHBOARD}_ADMIN`,
                            `${pageConstant?.LOCATE_DASHBOARD}_RW`,
                          ])
                            ? appColor
                            : "",
                          color: "white",
                        }}
                      >
                        {"Top-up"}
                      </Button>
                    )}

                    <Button
                      size="small"
                      onClick={() => {
                        onSubmitLocate(false, true, false);
                      }}
                      className={`ms-2 p-2 px-4 ${
                        isSmallerDeviceRes ? "col-4 mt-2" : ""
                      }`}
                      variant="contained"
                      disabled={
                        !hasAccess([
                          `${pageConstant?.LOCATE_DASHBOARD}_ADMIN`,
                          `${pageConstant?.LOCATE_DASHBOARD}_RW`,
                          `${pageConstant?.LOCATE_CLIENT}_ADMIN`,
                          `${pageConstant?.LOCATE_CLIENT}_RW`,
                        ])
                      }
                      style={{
                        backgroundColor: hasAccess([
                          `${pageConstant?.LOCATE_DASHBOARD}_ADMIN`,
                          `${pageConstant?.LOCATE_DASHBOARD}_RW`,
                          `${pageConstant?.LOCATE_CLIENT}_ADMIN`,
                          `${pageConstant?.LOCATE_CLIENT}_RW`,
                        ])
                          ? appColor
                          : "",
                        color: "white",
                      }}
                    >
                      {"Request"}
                    </Button>
                  </>
                )}

                {selectedTab === "Pre Borrow" && (
                  <>
                    <div
                      className={`${
                        isSmallerDeviceRes ? "col-6 mt-2" : "me-1 "
                      } div-wrapper-11`}
                    >
                      <TextField
                        size="small"
                        onChange={handleChange("value")}
                        value={values.value}
                        id="value"
                        label="Value"
                        type="number"
                        error={isOverrideSubmitted && !values?.value}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ inputProps: { min: 0 } }}
                        onBlur={onValueBlur}
                        inputRef={valueRef}
                      />
                    </div>
                    <Button
                      size="medium"
                      onClick={submitPreBorrow}
                      className={`ms-2 me-1 ${
                        isSmallerDeviceRes ? "col mt-1" : ""
                      }`}
                      variant="contained"
                      disabled={
                        !isAdmin ||
                        !hasAccess([
                          `${pageConstant?.LOCATE_DASHBOARD}_ADMIN`,
                          `${pageConstant?.LOCATE_DASHBOARD}_RW`,
                          `${pageConstant?.LOCATE_CLIENT}_ADMIN`,
                          `${pageConstant?.LOCATE_CLIENT}_RW`,
                        ])
                      }
                      style={{
                        backgroundColor:
                          isAdmin &&
                          hasAccess([
                            `${pageConstant?.LOCATE_DASHBOARD}_ADMIN`,
                            `${pageConstant?.LOCATE_DASHBOARD}_RW`,
                            `${pageConstant?.LOCATE_CLIENT}_ADMIN`,
                            `${pageConstant?.LOCATE_CLIENT}_RW`,
                          ])
                            ? appColor
                            : "",
                        color: "white",
                      }}
                    >
                      {isAdmin ? "Add" : "Request"}
                    </Button>
                  </>
                )}
                <Divider
                  orientation="vertical"
                  variant="fullWidth"
                  sx={{ marginLeft: 2, borderRightWidth: 4 }}
                />
              </div>

              <div
                className={`ps-1 ${
                  isAdmin ? "" : "align-content-center"
                }  div-wrapper-12 ${
                  is14to16Res
                    ? "col-12 mt-1 ps-1"
                    : "col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xxl-6"
                }`}
              >
                {renderTickerDetails()}
              </div>
            </div>
          )}
        </div>

        <hr className="mt-1 mb-1" />
        <div className="d-flex flex-row div-wrapper-13">
          <div className="d-flex flex-row justify-content-start align-items-center align-content-center col-9 div-wrapper-14">
            {(selectedTab !== 'Enquiry') && (
              <>
                <div
                  className="globalfiltermaindivLocate col-3 div-wrapper-15"
                  style={{ height: "2rem", marginLeft: "0.5rem" }}
                >
                  <input
                    type="search"
                    placeholder="Global search..."
                    id="filter-text-box-sec"
                    onInput={onFilterTextChange}
                    ref={globalSearchRef}
                  />
                </div>
              </>
            )}
            {selectedTab === "Most Located" && (
              <>
                <div className="form-check form-switch d-flex align-items-center justify-content-end ms-4 div-wrapper-37">
                  <input
                    checked={isShowFilledLocates}
                    onChange={() => {
                      const isShowFilled = !isShowFilledLocates;
                      setIsShowFilledLocates(isShowFilled);
                      onShowFilledLocates?.(isShowFilled);
                    }}
                    className={`form-check-input me-2 cursor-pointer`}
                    type="checkbox"
                    role="switch"
                    id="showFilledLocates"
                    title="Show only filled"
                    style={{ fontSize: "large" }}
                  />
                  <label
                    className="form-check-label text-nowrap mb-0 align-self-center mt-1"
                    htmlFor="showFilledLocates"
                    style={{ fontSize: "medium", marginLeft: "4px" }}
                  >
                    Show Only Filled
                  </label>
                </div>
              </>
            )}
            {selectedTab === "Locates" && (
              <>
                <div className="d-flex flex-row justify-content-start ms-4 align-baseline align-self-center align-items-center div-wrapper-16">
                  <div
                    className="border p-2 d-flex align-items-center justify-content-between position-relative div-wrapper-17"
                    style={{
                      height: "35px",
                      borderColor: "#ccc",
                      borderWidth: "1px",
                      borderStyle: "solid",
                      borderRadius: "5px",
                    }}
                  >
                    <div
                      className="position-absolute bg-white div-wrapper-18"
                      style={{
                        top: "-1px",
                        left: "9px",
                        width: "47px",
                        height: "5px",
                      }}
                    ></div>

                    <label
                      className="position-absolute px-1"
                      style={{
                        top: "-10px",
                        left: "10px",
                        fontSize: "12px",
                        paddingInline: "5px",
                      }}
                    >
                      Source
                    </label>

                    <div className="d-flex gap-2 div-wrapper-19">
                      <div className="form-check d-flex align-items-center div-wrapper-20">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="ui"
                          onChange={onUIFilter}
                          checked={isUIFilterActive}
                          style={{ fontSize: "12px" }}
                        />
                        <label
                          className="form-check-label ms-1"
                          htmlFor="ui"
                          style={{ fontSize: "12px", fontWeight: 600 }}
                        >
                          UI
                        </label>
                      </div>

                      <div className="form-check d-flex align-items-center div-wrapper-21">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="file"
                          onChange={onFileFilter}
                          checked={isFileFilterActive}
                          style={{ fontSize: "12px" }}
                        />
                        <label
                          className="form-check-label ms-1"
                          htmlFor="file"
                          style={{ fontSize: "12px", fontWeight: 600 }}
                        >
                          File
                        </label>
                      </div>

                      <div className="form-check d-flex align-items-center div-wrapper-22">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="fix"
                          onChange={onFixFilter}
                          checked={isFixFilterActive}
                          style={{ fontSize: "12px" }}
                        />
                        <label
                          className="form-check-label ms-1"
                          htmlFor="fix"
                          style={{ fontSize: "12px", fontWeight: 600 }}
                        >
                          Fix
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex flex-row justify-content-start ms-4 align-baseline align-self-center align-items-center div-wrapper-23">
                  <div
                    className="border p-2 d-flex align-items-center justify-content-between position-relative div-wrapper-24"
                    style={{
                      height: "35px",
                      borderColor: "#ccc",
                      borderWidth: "1px",
                      borderStyle: "solid",
                      borderRadius: "5px",
                    }}
                  >
                    <div
                      className="position-absolute bg-white div-wrapper-25"
                      style={{
                        top: "-1px",
                        left: "9px",
                        width: "45px",
                        height: "5px",
                      }}
                    ></div>

                    <label
                      className="position-absolute px-1"
                      style={{
                        top: "-10px",
                        left: "10px",
                        fontSize: "12px",
                        paddingInline: "5px",
                      }}
                    >
                      Status
                    </label>

                    <div className="d-flex gap-2 flex-row div-wrapper-26">
                      <div className="form-check d-flex align-items-center div-wrapper-27">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="new"
                          onChange={() => {
                            setStatusFilter((status: any) => {
                              return {
                                ...status,
                                isNewFilterActive: !status?.isNewFilterActive,
                              };
                            });
                          }}
                          checked={statusFilter?.isNewFilterActive}
                          style={{ fontSize: "12px" }}
                        />
                        <label
                          className="form-check-label ms-1"
                          htmlFor="new"
                          style={{ fontSize: "12px", fontWeight: 600 }}
                        >
                          New
                        </label>
                      </div>

                      <div className="form-check d-flex align-items-center div-wrapper-28">
                        <input
                          style={{ fontSize: "12px" }}
                          className="form-check-input"
                          type="checkbox"
                          id="approved"
                          onChange={() => {
                            setStatusFilter((status: any) => {
                              return {
                                ...status,
                                isApprovedFilterActive:
                                  !status?.isApprovedFilterActive,
                              };
                            });
                          }}
                          checked={statusFilter?.isApprovedFilterActive}
                        />
                        <label
                          className="form-check-label ms-1"
                          htmlFor="approved"
                          style={{ fontSize: "12px", fontWeight: 600 }}
                        >
                          Approved
                        </label>
                      </div>

                      <div className="form-check d-flex align-items-center div-wrapper-29">
                        <input
                          style={{ fontSize: "12px" }}
                          className="form-check-input"
                          type="checkbox"
                          id="topup"
                          onChange={() => {
                            setStatusFilter((status: any) => {
                              return {
                                ...status,
                                isTopupFilterActive:
                                  !status?.isTopupFilterActive,
                              };
                            });
                          }}
                          checked={statusFilter?.isTopupFilterActive}
                        />
                        <label
                          className="form-check-label ms-1 text-nowrap"
                          htmlFor="topup"
                          style={{ fontSize: "12px", fontWeight: 600 }}
                        >
                          Top-up
                        </label>
                      </div>

                      <div className="form-check d-flex align-items-center div-wrapper-30">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="rejected"
                          style={{ fontSize: "12px" }}
                          onChange={() => {
                            setStatusFilter((status: any) => {
                              return {
                                ...status,
                                isRejectedFilterActive:
                                  !status?.isRejectedFilterActive,
                              };
                            });
                          }}
                          checked={statusFilter?.isRejectedFilterActive}
                        />
                        <label
                          className="form-check-label ms-1"
                          htmlFor="rejected"
                          style={{ fontSize: "12px", fontWeight: 600 }}
                        >
                          Rejected
                        </label>
                      </div>

                      <div className="form-check d-flex align-items-center div-wrapper-31">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="partial"
                          style={{ fontSize: "12px" }}
                          onChange={() => {
                            setStatusFilter((status: any) => {
                              return {
                                ...status,
                                isPartialFilterActive:
                                  !status?.isPartialFilterActive,
                              };
                            });
                          }}
                          checked={statusFilter?.isPartialFilterActive}
                        />
                        <label
                          className="form-check-label ms-1"
                          htmlFor="partial"
                          style={{ fontSize: "12px", fontWeight: 600 }}
                        >
                          Partial
                        </label>
                      </div>

                      <div className="form-check d-flex align-items-center div-wrapper-32">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="pending"
                          style={{ fontSize: "12px" }}
                          onChange={() => {
                            setStatusFilter((status: any) => {
                              return {
                                ...status,
                                isPendingFilterActive:
                                  !status?.isPendingFilterActive,
                              };
                            });
                          }}
                          checked={statusFilter?.isPendingFilterActive}
                        />
                        <label
                          className="form-check-label ms-1"
                          htmlFor="pending"
                          style={{ fontSize: "12px", fontWeight: 600 }}
                        >
                          Pending
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="div-wrapper-33">
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    className="ms-4 icon-cursor-pointer"
                    onClick={onResetFilters}
                    sx={{ cursor: "pointer", height: "25px" }}
                  >
                    Reset
                  </Button>
                </div>

                <div className="ms-2 div-wrapper-34">
                  <div className="form-check form-switch d-flex align-items-center ms-2 div-wrapper-35">
                    <input
                      checked={showTotalRow}
                      onChange={onShowTotalToggle}
                      className="form-check-input me-2"
                      type="checkbox"
                      role="switch"
                      id="toggleAggRow"
                      title="Turn on/off totals"
                      style={{ fontSize: "medium" }}
                    />
                    <label
                      className="form-check-label text-nowrap mb-0 align-self-center mt-1"
                      htmlFor="toggleAggRow"
                      style={{ fontSize: "small", marginLeft: "4px" }}
                      title="Toggle total row in grid"
                    >
                      {"Show Totals"}
                    </label>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="col-3 d-flex flex-row justify-content-end align-items-center div-wrapper-36">
            {(selectedTab === "Locates" || selectedTab === "Pre Borrow") && (
              <div className="d-flex flex-row align-items-center me-1 div-wrapper-37">
                {isAdmin && selectedTab === "Locates"  && (
                  <>
                    <IconButton
                      title="Approve"
                      onClick={() =>
                        onMultiLocateUpdate(false, LocateStatus.Approved)
                      }
                      // disabled={isMultiApproveDisable}
                      disabled={
                        isMultiApproveDisable ||
                        isSecurityNotAvailable ||
                        isRegShoProhibited
                      }
                      className="ms-1"
                    >
                      <DoneIcon
                        className={`${
                          // isMultiApproveDisable
                          isMultiApproveDisable ||
                          isSecurityNotAvailable ||
                          isRegShoProhibited
                            ? "locate-grid-icon-disable"
                            : "locate-grid-icon-add"
                        }`}
                      />
                    </IconButton>

                    <IconButton
                      title="Reject"
                      disabled={isMultiRejectDisable}
                      onClick={() =>
                        onMultiLocateUpdate(false, LocateStatus.Rejected)
                      }
                      className={`${
                        isMultiRejectDisable
                          ? "locate-grid-icon-disable"
                          : "locate-grid-icon-reject"
                      }`}
                    >
                      <ClearIcon
                        className={`${
                          isMultiRejectDisable
                            ? "locate-grid-icon-disable"
                            : "locate-grid-icon-reject"
                        }`}
                      ></ClearIcon>
                    </IconButton>

                    <IconButton
                      title="Save"
                      disabled={isMultiSaveDisable}
                      onClick={() => onMultiLocateUpdate(true)}
                      className={`${
                        isMultiSaveDisable ? "locate-grid-icon-disable" : ""
                      }`}
                    >
                      <SaveIcon
                        className={`${
                          isMultiSaveDisable ? "locate-grid-icon-disable" : ""
                        }`}
                      ></SaveIcon>
                    </IconButton>
                  </>
                )}

                <button
                  onClick={() => {
                    setIsBulkUploadOpen(true);
                    setRowsToUpload([]);
                    setExcelFileName("");
                  }}
                  className="metrics-btn p-2 h-65 d-flex align-items-center btn btn-primary text-nowrap"
                  disabled={
                    (selectedTab === "Pre Borrow" ? !isAdmin : false) ||
                    !hasAccess([
                      `${pageConstant?.LOCATE_DASHBOARD}_ADMIN`,
                      `${pageConstant?.LOCATE_DASHBOARD}_RW`,
                      `${pageConstant?.LOCATE_CLIENT}_ADMIN`,
                      `${pageConstant?.LOCATE_CLIENT}_RW`,
                    ])
                  }
                  style={{ height: "25px" }}
                >
                  {"Bulk Upload"}
                </button>

                {isAdmin && selectedTab === "Locates"  && (
                  <>
                    <button
                      onClick={() => {
                        bulkUploadLocates(rowsToSubmit, true, true);
                      }}
                      className="metrics-btn p-2 h-65 d-flex align-items-center btn btn-primary ms-2 me-1 text-nowrap"
                      disabled={isTopupRequestDisable}
                      title={"Top-up"}
                      style={{ height: "25px" }}
                    >
                      Top-up
                    </button>
                  </>
                )}

                <button
                  onClick={() => {
                    bulkUploadLocates(rowsToSubmit, true, false);
                  }}
                  className="metrics-btn p-2 h-65 d-flex align-items-center btn btn-primary ms-2 me-1"
                  disabled={isTopupRequestDisable}
                  style={{ height: "25px" }}
                >
                  Request
                </button>

                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  className={`ms-2 icon-cursor-pointer ${
                    isClearDisable ? "locate-grid-icon-disable" : ""
                  }`}
                  onClick={onLocatesClear}
                  sx={{ cursor: "pointer", height: "25px" }}
                  disabled={isClearDisable}
                >
                  Clear
                </Button>
              </div>
            )}

            {(selectedTab !== 'Enquiry') && (
              <>
                <span
                  className="borrowExceldnld float-start ms-1 div-wrapper-38"
                  onClick={onExcelExport}
                  title="Download Excel"
                >
                  <img
                    src={excel}
                    alt=""
                    style={{
                      height: "1.8rem",
                      width: "1.8rem",
                      cursor: "pointer",
                    }}
                  />
                </span>

                <div
                  className="d-flex justify-content-end align-items-center cursor-pointer ms-1 pl-0 div-wrapper-39"
                  onClick={onRefresh}
                  title="Refresh Data"
                >
                  <RefreshIcon
                    style={{
                      cursor: "pointer",
                      marginRight: "0.5rem",
                      color: "#1E355E",
                    }}
                    titleAccess={`Last updated on: ${lastUpdatedDate}`}
                  />
                </div>
              </>
            )}
          </div>
        </div>
        <Dialog
          open={showSkippedRowPopup}
          onClose={(event: any, reason: any) => {
            if (
              reason &&
              (reason == "backdropClick" || reason == "escapeKeyDown")
            ) {
              return;
            }
            setShowSkippedRowPopup(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="rows-skipped"
          maxWidth={"md"}
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{ backgroundColor: appColor }}
          >
            <Typography sx={{ color: "white" }}>Warning</Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="rows-skipped">
              <div className="div-wrapper-40">
                <div className="div-wrapper-41">
                  These rows were skipped:{" "}
                  {rowsToSkip.length > 0 ? _.join(rowsToSkip, ",") : rowsToSkip}
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-actions-dense">
            <button
              className="metrics-btn p-2 h-65 d-flex align-items-center btn btn-primary"
              onClick={() => {
                setShowSkippedRowPopup(false);
                setRowsToSkip([]);
              }}
            >
              Close
            </button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={isBulkUploadOpen}
          onClose={handleBulkUploadClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="rows-skipped"
          maxWidth="lg"
          PaperProps={{ sx: { minWidth: "600px" } }}
        >
          <DialogTitle
            id="alert-dialog-title"
            className="p-2"
            sx={{ backgroundColor: appColor }}
          >
            <Typography sx={{ color: "white" }}>Upload File</Typography>
          </DialogTitle>
          <DialogContent className="pb-0">
            <DialogContentText id="rows-skipped" className="pb-0">
              <div className="mt-1 d-flex flex-column justify-content-around align-items-center div-wrapper-42">
                <div className="upload-btn-main-div div-wrapper-43">
                  {excelFileName === "" ? (
                    <button className="excel-upload-btn float-end mb-1 mt-1">
                      <input
                        type="file"
                        className="FileUpload"
                        onChange={onUploadExcel}
                        accept=".xlsx,.xlsm,.xlsb,.xltx,.xltm,.xlt,.xls,.xls"
                      />
                      <div className="dropZoneOverlay div-wrapper-44">
                        <Icon
                          style={{
                            color: "#1E355E",
                            marginBottom: "0.1rem",
                            marginRight: "0.5rem",
                            height: "1.21rem",
                            width: "1.25rem",
                          }}
                          icon="material-symbols-light:add-circle"
                        />
                        Upload File
                      </div>
                    </button>
                  ) : (
                    <div className="file-name me-3 div-wrapper-45">
                      {excelFileName}
                      {excelFileName === "" ? (
                        ""
                      ) : (
                        <Icon
                          onClick={onClear}
                          style={{
                            color: "#E90909",
                            height: "0.9rem",
                            cursor: "pointer",
                          }}
                          icon="material-symbols-light:cancel"
                        />
                      )}
                    </div>
                  )}
                </div>
                <div className="mt-1 div-wrapper-46">
                  <a
                    style={{ width: "11rem", fontSize: "1rem" }}
                    href="/locates-dashboard-bulkupload-template.xlsx"
                    download
                    className="templetelink float-end me-0 text-nowrap"
                  >
                    Download Blank Template
                  </a>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-actions-dense">
            <button
              className="me-1 metrics-btn p-2 h-65 d-flex align-items-center btn btn-primary"
              onClick={onBulkSubmit}
              disabled={rowsToUpload?.length === 0}
            >
              Submit
            </button>
            <button
              className="metrics-btn p-2 h-65 d-flex align-items-center btn btn-primary"
              onClick={() => {
                setIsBulkUploadOpen(false);
                setRowsToUpload([]);
              }}
            >
              Close
            </button>
          </DialogActions>
        </Dialog>

        <ToastContainer />
      </div>
      <Dialog
        open={isFillPopupOpen}
        onClose={handleDialogClose}
        maxWidth="lg"
        PaperProps={{ sx: { minWidth: "450px" } }}
      >
        <DialogTitle
          id="fill-order-dialog-title"
          className="p-2"
          sx={{ backgroundColor: appColor }}
        >
          <Typography sx={{ color: "white" }}>Replenish Supply</Typography>
        </DialogTitle>

        <DialogContent className="pb-0">
          <div
            className="div-wrapper-47"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr",
              gap: "0.5rem",
              width: "100%",
              marginTop: "3%",
            }}
          >
            <div className="div-wrapper-48">
              <Typography variant="body2" fontWeight="500">
                Lender<span style={{ color: "red" }}>*</span>
              </Typography>
              <Select
                value={
                  lenderOptions.find((opt) => opt.label === fillForm.lender) ||
                  null
                }
                onChange={(selectedOption: any) => {
                  setFillForm((prev) => ({
                    ...prev,
                    lender: selectedOption?.label || "",
                  }));
                  if (selectedOption?.label) {
                    setFormErrors((prev) => ({ ...prev, lender: false }));
                  }
                }}
                options={lenderOptions}
                placeholder="Select Lender"
                isClearable
                styles={
                  {
                    /* custom styles */
                  }
                }
              />
              {formErrors.lender && (
                <Typography variant="caption" color="error">
                  Lender is required
                </Typography>
              )}
            </div>

            {/* Ticker */}
            <div className="div-wrapper-49">
              <Typography variant="body2" fontWeight="500">
                Ticker (sec_id)<span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                fullWidth
                placeholder="Ticker"
                value={fillForm.ticker}
                InputProps={{ readOnly: true }}
                margin="dense"
                error={formErrors.ticker}
                helperText={formErrors.ticker ? "Ticker is required" : ""}
                sx={{
                  "& .MuiInputBase-root": {
                    height: "40px",
                    fontSize: "14px",
                    padding: "0 10px",
                  },
                  "& input": {
                    height: "40px",
                    fontSize: "14px",
                    padding: "0 10px",
                  },
                }}
              />
            </div>

            {/* Quantity */}
            <div className="div-wrapper-50">
              <Typography variant="body2" fontWeight="500">
                Quantity<span style={{ color: "red" }}>*</span>
              </Typography>
              <TextField
                fullWidth
                type="number"
                placeholder="Enter Quantity"
                value={fillForm.quantity}
                onChange={(e) => {
                  const value = e.target.value;

                  if (value === "") {
                    setFillForm({ ...fillForm, quantity: "" });
                    return;
                  }

                  if (value.includes(".") || !/^\d+$/.test(value)) {
                    return;
                  }

                  const number = Number(value);

                  if (number < 1 || value.length > 12) {
                    setFormErrors((prev) => ({ ...prev, quantity: true }));
                    setFillForm({ ...fillForm, quantity: value });
                    return;
                  }

                  setFillForm({ ...fillForm, quantity: value });
                  setFormErrors((prev) => ({ ...prev, quantity: false }));
                }}
                inputProps={{
                  min: 1,
                  step: 1,
                  onKeyDown: (e) => {
                    if (
                      ["-", "e", ".", ","].includes(e.key) ||
                      (e.key === "0" && e.currentTarget.value === "")
                    ) {
                      e.preventDefault();
                    }
                  },
                }}
                error={formErrors.quantity}
                helperText={
                  formErrors.quantity
                    ? "Invalid Quantity – You cannot enter a quantity greater than 12 digits."
                    : ""
                }
                margin="dense"
                sx={{
                  "& .MuiInputBase-root": {
                    height: "40px",
                    fontSize: "14px",
                    padding: "0 10px",
                  },
                  "& input": {
                    height: "40px",
                    fontSize: "14px",
                    padding: "0 10px",
                  },
                }}
              />
            </div>

            <Typography variant="body2" fontWeight="500">
              Rate <span style={{ color: "gray" }}>(Optional)</span>
            </Typography>
            <TextField
              fullWidth
              type="text"
              placeholder="Enter Rate (e.g. 123.4567)"
              value={fillForm.rate}
              onChange={(e) => {
                const value = e.target.value;
                const regex = /^-?\d{0,3}(\.\d{0,4})?$/;

                if (value === "" || regex.test(value)) {
                  setFillForm({ ...fillForm, rate: value });
                  setFormErrors((prev) => ({ ...prev, rate: false }));
                }
              }}
              onKeyDown={(e) => {
                // block unwanted keys
                if (["e", "+", ",", " "].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onBlur={() => {
                const value = fillForm.rate.trim();
                // validate again on blur
                if (value !== "" && !/^-?\d*(\.\d{0,4})?$/.test(value)) {
                  setFormErrors((prev) => ({ ...prev, rate: true }));
                } else {
                  setFormErrors((prev) => ({ ...prev, rate: false }));
                }
              }}
              error={formErrors.rate}
              helperText={
                formErrors.rate
                  ? "Invalid format. Only numbers with up to 4 decimal places are allowed."
                  : ""
              }
              margin="dense"
              sx={{
                "& .MuiInputBase-root": {
                  height: "40px",
                  fontSize: "14px",
                  padding: "0 10px",
                },
                "& input": {
                  height: "40px",
                  fontSize: "14px",
                  padding: "0 10px",
                },
              }}
            />
          </div>

          <DialogActions className="dialog-actions-dense">
            <button
              className="metrics-btn p-2 h-65 d-flex align-items-center btn btn-primary"
              onClick={handleFillFormClose}
              style={{
                height: "40px",
                fontSize: "14px",
                padding: "0 16px",
              }}
            >
              Cancel
            </button>

            <button
              className="metrics-btn p-2 h-65 d-flex align-items-center btn btn-primary"
              onClick={submitFillData}
              style={{
                height: "40px",
                fontSize: "14px",
                padding: "0 16px",
              }}
            >
              Submit
            </button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default LocateAdders;
